/* Language pack: tr */
export const translationsTr = {
	resumeRecording: "Devam et",
	chatCallMissed: "Cevapsız",
	chatCallDeclined: "Reddedildi",
	chatAudioConference: "Sesli konferans",
	chatVideoConference: "Video konferans",

	IDCardImages: "Kimlik kartı resimleri",
	IT: "BT",
	Status: "Durum",
	abbreviation: "Kısaltma",
	aboutUsItems: "Hakkımızda Öğeleri",
	absent: "Yok",
	accept: "Kabul Et",
	actSendingDate: "Akt Gönderme Tarihi",
	actionTimestamp: "Eylem zaman damgası",
	actionType: "Eylem türü",
	actions: "İşlemler",
	activateStep7_8_9: "Güç İletim Hatları Departmanına atama ( 7, 8, 9 )",
	activateStep8: "Jeodezi departmanına atama ( 8 )",
	activatedProjects: "Etkinleştirilen Projeler",
	active: "Aktif",
	activeCarts: "Aktif Sepetler",
	activeClients: "Aktif Müşteriler",
	activeCustomers: "Aktif Müşteriler",
	activeProjectSteps: "Aktif proje adımları",
	activePromos: "Aktif Promosyonlar",
	activeSales: "Aktif Satışlar",
	activeSalesEvents: "Aktif Satış Etkinlikleri",
	activeServices: "aktif hizmetler",
	activeSteps: "Aktif adımlar",
	activeStreams: "Aktif Akışlar",
	activeTasks: "Aktif görevler",
	activeTime: "Aktif zaman",
	activity: "Aktivite",
	actualHours: "Gerçek Saat",
	adInterval: "Reklam aralığı",
	adIntervalOverride: "Planlama kuralları",
	adIntervalOverrideDesc: "Planlama kuralları",
	adIntervalOverrideValue: "Planlama kuralları",
	adPlaylist: "Reklam çalma listesi",
	adPlaylists: "Reklam Çalma Listeleri",
	adTracks: "Reklam Parçaları",
	add: "Ekle",
	addAttendance: "Devamsızlık Ekle",
	addFeature: "Özellik ekle",
	addFeatureLine: "Özellik satırı ekle",
	addFiles: "Dosya ekle",
	addMoreFiles: "Daha fazla dosya ekle",
	addNew: "Yeni Ekle",
	addPriceLine: "Fiyat satırı ekle",
	addRule: "Kural ekle",
	addToList: "Listeye ekle",
	addVacationInterval: "Tatil aralığı ekle",
	added: "Eklendi",
	additionalDetails: "Ek Detaylar",
	address: "Adres",
	addressData: "Adres Verileri",
	advanceDeductions: "Avans kesintileri",
	advertisement: "Reklam",
	age: "Yaş",
	ageGroups: "Yaş Grupları",
	ago: "önce",
	agreedProjects: "Onaylanmış Projeler",
	agreementAquipment: "Ekipman üzerinde anlaşma",
	aiConversations: "Konuşmalar",
	album: "Albüm",
	allArtists: "tüm sanatçılar",
	allAudioTracks: "tüm ses parçaları",
	allContentItems: "tüm içerik öğeleri",
	allFilesDeleted: "Tüm dosyalar kalıcı olarak silindi",
	allFilesWillBeDeleted: "Tüm dosyalar kalıcı olarak silinecek",
	allPlaylists: "tüm çalma listeleri",
	allRegisteredContacts: "tüm kayıtlı müşteriler",
	allTickets: "Tüm Biletler",
	amount: "Miktar",
	analytics: "Analitik",
	answer: "Cevap",
	apartment: "Daire",
	apply: "Uygula",
	appsMenu: "Uygulamalar menüsü",
	approved: "Onaylandı",
	approvedInterval: "Onaylı aralık",
	archive: "Arşiv",
	archived: "Arşiv",
	areYouSure: "Emin misiniz?",
	areYouSureToDelete: "Bunu silmek istediğinizden emin misiniz?",
	artist: "Sanatçı",
	artistObject: "Sanatçı nesnesi",
	assignedTo: "Atanan",
	assignedToUser: "Atanan",
	assignmentToTheConstructionDepartment: "İnşaat departmanına atama",
	attach: "Ekle",
	attachFile: "Dosya ekle",
	attachments: "Ekler",
	attendance: "Devamsızlık",
	attendanceFlag: "Devam durumu",
	attendanceRequiringAttention: "Dikkat Gerektiren Çalışanlar",
	attendanceNoAttentionItems: "Dikkat gerektiren çalışan yok",
	attendanceMissingCheckIn: "Giriş kaydı yok",
	attendanceMissingCheckOut: "Çıkış kaydı yok",
	attendanceEarlyLeave: "Erken çıkış",
	attendanceEarlyMissings: "Erken ayrılmalar",
	attendanceEarlyMissingHours: "Erken ayrılma saatleri",
	attendanceLateHours: "Geç kalma saatleri",
	attendanceShowWorkedHours: "Çalışılan saatleri göster",
	attendanceUnapprovedAbsence: "Onaylanmamış devamsızlık",
	attendanceDeptAttendance: "Departman Devamsızlığı",
	attendanceDeviceHealth: "Cihaz Durumu ve Canlı Senkronizasyon",
	attendanceLastSync: "Son senkronizasyon",
	attendanceLiveFeed: "Canlı Devam Akışı",
	attendanceNoRecentPunches: "Son kayıt yok",
	attendanceManualEntryTag: "Manuel",
	attendanceUnmappedPunch: "Eşleşmemiş",
	attendancePendingItems: "beklemede",
	flexCardTotal: "Flex kartlar",
	attendanceCards: "Devam kartları",
	flexCardTotalSubtitle: "Atanmış veya yok sayılan Flex ID'ler",
	flexCardsAttached: "Bağlı",
	flexCardsAttachedSubtitle: "Kullanıcılara bağlı benzersiz ID'ler",
	flexCardsIgnored: "Yok sayıldı",
	flexCardsIgnoredSubtitle: "İK ayarlarında yok sayıldı",
	flexCardsDuplicateAttached: "Tekrar bağlanmış",
	flexCardIds: "kart ID'leri",
	noDuplicateFlexCards: "Tekrar yok",
	attendanceTrendPctOfEmployeesPresent: "Çalışanların katılım yüzdesi",
	yesterday: "Dün",
	attendanceFilterThisWeek: "Bu Hafta",
	attendanceFilterThisMonth: "Bu Ay",
	attendanceFilterCustom: "Özel",
	attendanceSelectRange: "Aralık seçin",
	attendanceCustomRangeCapped: "Özel aralık 90 gün ile sınırlıdır",
	attendanceLiveBadge: "LIVE",
	attendanceTitleToday: "Bugünkü Devam",
	attendanceTitleYesterday: "Dünkü Devam",
	attendanceTitleThisWeek: "Bu Haftaki Devam",
	attendanceTitleThisMonth: "Bu Ayki Devam",
	attendanceTitleCustom: "Seçilen Dönemin Devamı",
	attendanceTitleTodayKpis: "Bugünkü Devam KPI'ları",
	attendanceTitleYesterdayKpis: "Dünkü Devam KPI'ları",
	attendanceTitleThisWeekKpis: "Bu Haftaki Devam KPI'ları",
	attendanceTitleThisMonthKpis: "Bu Ayki Devam KPI'ları",
	attendanceTitleCustomKpis: "Seçilen Dönemin KPI'ları",
	attendanceTrendDays: "Devam Trendi — Son {n} Gün",
	attendanceNotAttendedYet: "Henüz Gelmedi",
	attendanceUpcomingAbsences: "Yaklaşan İzinler",
	attendanceUpcomingAbsencesEmpty: "Yaklaşan izin yok",
	attendanceUpcomingAbsencesTomorrow: "Yarın",
	attendanceUpcomingAbsencesInDays: "{days} gün içinde",
	attendanceExceptions: "Devam İstisnaları",
	attendanceExceptionsMissingCheckIn: "Eksik Girişler",
	attendanceExceptionsMissingCheckOut: "Eksik Çıkışlar",
	attendanceExceptionsEarlyLeaves: "Erken Ayrılmalar",
	attendanceExceptionsUnapprovedAbsences: "Onaylanmamış Devamsızlıklar",
	attendanceExceptionsDuplicatePunches: "Tekrarlanan Kayıtlar",
	attendanceMonthlyKpis: "Aylık Devam KPI'ları",
	attendanceKpiRate: "Devam Oranı",
	attendanceKpiAvgArrival: "Ortalama Varış",
	attendanceKpiLateArrivals: "Geç Kalmalar",
	attendanceKpiAbsentDays: "Devamsız Günler",
	attendanceKpiOvertimeHours: "Fazla Mesai Saatleri",
	attendanceLeaveBalanceOverview: "İzin Bakiyesi Özeti",
	attendanceLeaveBalanceVacationRemaining: "Kalan İzin",
	attendanceLeaveBalanceSickUsed: "Kullanılan Hastalık İzni",
	attendanceLeaveBalanceBusinessTrips: "İş Seyahatleri",
	attendanceLeaveBalancePendingRequests: "Bekleyen Talepler",
	attendanceLeaveBalanceCoverage: "{total} çalışandan {covered}",
	attendanceTopInsights: "Öne Çıkan Devam Analizleri",
	attendanceInsightNoData: "Henüz analiz yok",
	attendanceInsightHighestLateness: "{dept} bu hafta en yüksek geç kalma oranına sahip ({delta})",
	attendanceInsightFullAttendanceToday: "{dept} %100 devam gösterdi",
	attendanceInsightTrendImproved: "Devam oranı önceki döneme göre %{pct} arttı",
	attendanceInsightTrendDeclined: "Devam oranı önceki döneme göre %{pct} düştü",
	attendanceInsightApproachingOvertime: "{count} çalışan fazla mesai sınırına yaklaşıyor",
	attendancePreviousWeek: "Geçen Hafta",
	attendanceCurrentWeek: "Bu Hafta",
	attendanceAddInterval: "Aralık ekle",
	attendanceBreakLabel: "Mola",
	attendanceCorrectionMode: "Düzeltme modu",
	attendanceCustomIntervals: "Özel aralıklar",
	attendanceDashboard: "Devamsızlık Paneli",
	attendanceReports: "Raporlar",
	attendanceCalendarTab: "Takvim",
	reports: "Raporlar",
	shiftCoverage: "Vardiya kapsamı",
	previousPeriod: "Önceki dönem",
	nextPeriod: "Sonraki dönem",
	failedToSave: "Fazla mesai yorumu kaydedilemedi",
	expandForDailyDetail: "Günlük ayrıntı için satırı genişlet",
	noDataForPeriod: "Bu dönem için veri yok",
	attendanceHistory: "Devam geçmişi",
	attendanceDayOffTab: "İzin günü",
	attendanceDayType: "Gün türü",
	attendanceDetectedIntervals: "Algılanan aralıklar",
	attendanceEditDay: "Günü düzenle",
	attendanceHrsTotal: "sa toplam",
	attendanceViewWeek: "Hafta",
	attendanceViewMonth: "Ay",
	attendanceViewDay: "Gün",
	day: "Gün",
	attendanceOpenFrom: "{time} itibarıyla açık",
	attendanceFromStillActive: "{time} itibarıyla → hâlâ aktif",
	attendanceTotalWorked: "Toplam çalışılan",
	attendanceMissingUncovered: "Eksik / kapsanmayan",
	attendanceNoData: "Veri yok",
	attendanceNoDataForDay: "Bu gün için devam verisi yok.",
	attendanceIntervalApprovedOk: "Onaylandı / Tamam",
	attendanceIntervalEachRowInvalid: "Lütfen her aralık için geçerli başlangıç ve bitiş saati girin",
	attendanceIntervalTimesInvalid: "Lütfen geçerli başlangıç ve bitiş saati girin",
	attendanceIntervalsMode: "Aralıklar",
	attendanceIntervalsReviewHint:
		"Gerçek çalışılan, izin ve eksik aralıkları gözden geçirin. Aşağıya onaylı, iş, uzaktan, hastalık, ücretli izin, ücretsiz veya diğer olarak işaretlemek için manuel aralıklar ekleyin.",
	attendanceLogSubtitle: "Manuel devam girişi — iş, hastalık, izin",
	attendanceLogTitle: "Devam kaydı",
	attendanceManualResolutionIntervals: "Manuel düzeltme aralıkları",
	attendanceMissingLabel: "Eksik",
	attendanceNoManualIntervalsYet: "Henüz manuel aralık eklenmedi",
	attendanceNoUncovered: "Karşılıksız aralık tespit edilmedi",
	attendanceOptionalNotePlaceholder: "İsteğe bağlı not…",
	attendancePtoLeaveSection: "Ücretli izin / İzin",
	attendanceReport: "Devamsızlık Raporu",
	attendanceResolveInterval: "Bu aralığı gider",
	attendanceResyncTooltip: "Bu çalışanın devam durumunu yeniden senkronize et",
	attendanceResyncSuccess: "Devam durumu yeniden senkronizasyonu başlatıldı",
	attendanceResyncFailed: "Devam durumu yeniden senkronizasyonu başarısız oldu",
	attendanceSavedSuccess: "Devam başarıyla kaydedildi",
	attendanceStatusUpcoming: "Yaklaşan",
	attendanceSelectEmployeePrompt: "Devamı görmek için çalışan seçin",
	attendanceTrend: "Devam Trendi",
	attendanceTrendPctPresent: "% Mevcut",
	attendanceUncoveredMissing: "Karşılıksız / Eksik",
	attendanceUnsavedChanges: "Kaydedilmemiş değişiklikler",
	attendanceWholeDayStatus: "Tüm gün durumu",
	shiftWorker: "Vardiyalı çalışan",
	attendanceIgnoreMode: "Yoksay",
	attendanceIgnoreScopeWeekdays: "Haftanın günleri",
	attendanceIgnoreScopeDateRange: "Tarih aralığı",
	attendanceIgnoreScopeWeekdaysHint: "Yalnızca bu dönemdeki seçili haftanın günlerinde uygulanır.",
	attendanceIgnoreScopeDateRangeHint: "Bu dönemdeki her güne uygulanır.",
	attendanceIgnoreAppliesTo: "Uygulanacak durum",
	attendanceIgnoreLateArrival: "Geç gelme",
	attendanceIgnoreEarlyLeave: "Erken çıkış",
	attendanceIgnoreWindowStart: "Yoksayma aralığı başlangıcı",
	attendanceIgnoreWindowEnd: "Yoksayma aralığı bitişi",
	attendanceIgnoreRulesList: "Yoksayma kuralları",
	attendanceIgnoreRulesEmpty: "Henüz yoksayma kuralı yok",
	attendanceIgnoreDaysOfWeekRequired: "En az bir gün seçin",
	attendanceIgnoredLabel: "Yoksayıldı",
	attendanceNoCardLabel: "Kart Yok",
	attendanceWork: "İş",
	attendanceWorked: "Çalışılan",
	attendanceWorkedIntervals: "Çalışılan aralıklar",
	attendanceMissingIntervals: "Eksik aralıklar",
	attendanceStillInOffice: "Hâlâ ofiste",
	attendanceAddEvent: "Etkinlik ekle",
	attendanceAddAttendanceEvent: "Devam etkinliği ekle",
	attendanceDeleteEventTitle: "Devam etkinliği silinsin mi?",
	attendanceDeleteEventText: "Bu yalnızca manuel eklenen bu giriş/çıkış etkinliğini kaldırır.",
	attendanceNoMissingIntervals: "Bu gün için eksik aralık yok",
	attendanceOfficeSince: "{time} itibaren",
	attendanceLastOutAt: "Son çıkış {time}",
	attendanceEventSingular: "etkinlik",
	attendanceEventPlural: "etkinlik",
	attendancePunchIn: "Giriş",
	attendancePunchOut: "Çıkış",
	solveThis: "Bunu çöz",
	editSolvedStatus: "Çözülen durumu düzenle",
	officeStatus: "Ofis durumu",
	outOfOffice: "Ofis dışında",
	noPunches: "Kayıt yok",
	lastActionWasCheckIn: "Son işlem giriş",
	lastActionWasCheckOut: "Son işlem çıkış",
	noCheckInYet: "Henüz giriş yok",
	manual: "Manuel",
	resolved: "Çözüldü",
	attendanceManualStatusApplyTicketTimeTo: "Bilet süresini şuraya uygula",
	attendanceManualStatusColumnAttendanceType: "Devam türü",
	attendanceManualStatusColumnTimeAction: "Zaman işlemi",
	attendanceManualStatusMapsToType: "Devam türüne eşlenir",
	attendanceManualStatusTicketTimeAction: "Bilet otomasyonu zaman işlemi",
	attendanceTicketTimePhraseAdd: "{type} süresi ekle",
	attendanceTicketTimePhraseSubtract: "{type} süresi çıkar",
	attendanceTimeOpAdd: "Bilet süresi ekle",
	attendanceTimeOpNone: "Süre bakiyesinde değişiklik yok",
	attendanceTimeOpSubtract: "Bilet süresi çıkar",
	attendanceTypeOptionAbsent: "Yok",
	attendanceTypeOptionBusinessTrip: "İş seyahati",
	attendanceTypeOptionHolidayNonWorking: "Tatil / çalışılmayan",
	attendanceTypeOptionJustifiedAbsence: "Mazeretli devamsızlık (izinli)",
	attendanceTypeOptionMaternity: "Doğum izni",
	attendanceTypeOptionPaidVacation: "Ücretli izin",
	attendanceTypeOptionRemote: "Uzaktan çalışma",
	attendanceTypeOptionSickLeave: "Hastalık izni",
	attendanceTypeOptionUnjustifiedAbsence: "Mazeretsiz devamsızlık",
	attendanceTypeOptionUnpaidLeave: "Ücretsiz izin",
	attendanceTypeOptionWork: "İş",
	audio: "Ses",
	autoDeletion: "Otomatik silme",
	averageDailyHours: "Günlük ortalama saat",
	avgDaily: "Gunluk ortalama",
	avgDailyHours: "Gunluk ortalama saat",
	avgHoursPerWorkingDay: "Calisma gunu basina ortalama saat",
	avgOrderValue: "Ortalama Sipariş Değeri",
	avgResolutionTime: "Ortalama Çözüm Süresi",
	avgResponseTime: "Ortalama Yanıt Süresi",
	avgTracksPerPlaylist: "Ortalama Parça/Çalma Listesi",
	back: "Geri",
	bank: "Banka",
	bankAccount: "Banka Hesabı",
	bankCart: "Banka Kartı",
	bankEmitet: "Banka",
	banner: "Afiş",
	baseSalary: "Temel maaş",
	baseSalaryHourlyLinked:
		"Normal saatler > 0 iken saatlik ücreti temel ÷ normal saatlerden günceller.",
	basicInformation: "Temel Bilgiler",
	beginningOfAcquaintance: "Tanışmanın başlangıcı",
	beginningOfContract: "Sözleşmenin başlangıcı",
	beginningOfTraining: "Eğitimin başlangıcı",
	benefits: "Yan haklar",
	bestSeller: "En çok satan",
	bestSellers: "En Çok Satanlar",
	bestSellingItemsByRevenue: "Gelire Göre En Çok Satan Ürünler",
	bitrate: "Bit hızı",
	biweekly: "İki haftada bir",
	blogItems: "Blog Öğeleri",
	blogs: "Bloglar",
	bonuses: "Primler",
	bpm: "BPM",
	branch: "Elektrik Şebekesi Şubesi",
	branches: "Şube listesi",
	branchesCitiesVillages: "Şubeler, Şehirler, Köyler",
	brand: "Marka",
	brands: "Markalar",
	building: "Bina",
	businessTrip: "İş gezisi",
	buttonText: "Düğme metni",
	bypassSteps: "Adımları Atla",
	calAddCalendarTooltip: "Takvim oluştur ve ekiple paylaş",
	calAddEvent: "Etkinlik ekle",
	calAddReminder: "Hatırlatıcı ekle",
	calAlarm15m: "15 dk önce",
	calAlarm1d: "1 gün önce",
	calAlarm1h: "1 saat önce",
	calAlarm1w: "1 hafta önce",
	calAlarm2d: "2 gün önce",
	calAlarm2h: "2 saat önce",
	calAlarm30m: "30 dk önce",
	calAlarm5m: "5 dk önce",
	calAlarmAtEvent: "Etkinlik anında",
	calAllDay: "Tüm gün",
	calApiNotConfigured: "Takvim API yapılandırılmamış.",
	calCalendarColorLabel: "Takvim rengi",
	calCalendarCreateFailed: "Takvim oluşturulamadı",
	calCalendarCreated: "Takvim oluşturuldu",
	calCalendarDeleted: "Takvim silindi",
	calCalendarNameLabel: "Takvim adı",
	calCalendarNamePh: "örn. Ekip planlaması",
	calCalendarNameRequired: "Takvim adı girin",
	calCalendarSelect: "Takvim",
	calCalendarUpdateFailed: "Takvim güncellenemedi",
	calCalendarUpdated: "Takvim güncellendi",
	calCalendarsLabel: "Takvimler:",
	calGoogleCalendarLabel: "Google Takvim:",
	calGoogleCalendarPrefix: "Google",
	calMeetingsLabel: "Toplantılar:",
	calCancel: "İptal",
	calCheckAll: "Tümünü Seç",
	calColor: "Renk",
	calCreateCalendar: "Takvim oluştur",
	calDay: "Gün",
	calDayOverviewTitle: "Gün",
	calDefaultCalendarName: "Takvim",
	calDelete: "Sil",
	calDeleteCalendarHasEvents: "Bu takvimde {count} etkinlik var. Ne yapmak istersiniz?",
	calDeleteCalendarNoEvents: "Bu işlem geri alınamaz.",
	calDeleteCalendarOnly: "Yalnızca takvimi sil",
	calDeleteCalendarTitle: "Takvim silinsin mi?",
	calDeleteCalendarWithEvents: "Etkinliklerle sil",
	calDeleteEventText: "Bu işlem geri alınamaz.",
	calDeleteEventTitle: "Etkinlik silinsin mi?",
	calDeleteFailed: "Silme başarısız",
	calDescription: "Açıklama",
	calDescriptionPh: "İsteğe bağlı açıklama",
	calEditCalendarTitle: "Takvimi düzenle",
	calEditCalendarTooltip: "Takvimi düzenle",
	calEditEvent: "Etkinliği düzenle",
	calEditTooltip: "Düzenle",
	calEnd: "Bitiş",
	calEndBeforeStart: "Bitiş başlangıçtan önce olamaz",
	calEndTime: "Bitiş saati",
	calEvent: "Etkinlik",
	calEventCreated: "Etkinlik oluşturuldu",
	calEventDeleted: "Etkinlik silindi",
	calEventTitle: "Başlık",
	calEventTitlePh: "Etkinlik başlığı",
	calEventUpdated: "Etkinlik güncellendi",
	calEventsPlural: "etkinlik",
	calExportIcs: ".ics dışa aktar",
	calFailedLoadEvents: "Etkinlikler yüklenemedi",
	calHrBirthdayEvent: "Doğum günü",
	calHrBirthdays: "Doğum günleri",
	calHrContractEnd: "Sözleşme bitişi",
	calHrContractEndEvent: "Sözleşme sonu",
	calHrContractStart: "Sözleşme başlangıcı",
	calHrContractStartEvent: "Sözleşme başı",
	calHrIdEvent: "Kimlik son tarihi",
	calHrIdExpiry: "Kimlik bitişi",
	calHrPassportEvent: "Pasaport son tarihi",
	calHrPassportExpiry: "Pasaport bitişi",
	calHrPositionReview: "Pozisyon gözden geçirme",
	calHrPositionReviewEvent: "Pozisyon incelemesi",
	calHrSalaryReview: "Maaş gözden geçirme",
	calHrSalaryReviewEvent: "Maaş incelemesi",
	calImportButton: "İçe aktar",
	calImportEventsTitle: "Etkinlikleri içe aktar",
	calImportFoundInFile: "dosyada bulundu. İçe aktarmak için takvim seçin:",
	calImportIcs: ".ics içe aktar",
	calImportedEventTitle: "İçe aktarılan etkinlik",
	calItLabel: "BT:",
	calItWarrantyEnd: "Garanti Bitişi",
	calItWarrantyEndEvent: "Garanti Bitişi",
	calMonth: "Ay",
	calNewCalendarTitle: "Yeni takvim",
	calNewEvent: "Yeni etkinlik",
	calNoCalendar: "Takvim yok",
	calNoCalendarUncategorised: "Takvim yok (kategorisiz)",
	calNoEventsInIcs: ".ics dosyasında etkinlik yok",
	calNoEventsThisDay: "Bu gün etkinlik yok.",
	calNoRemindersThisDay: "Bu gün hatırlatıcı yok.",
	calDayWeatherMap: "Hava durumu haritası",
	calDayHourlyForecast: "Saatlik tahmin",
	calDayWeatherUnavailable: "Bu tarih için tahmin mevcut değil",
	calDayEventsSection: "Etkinlikler",
	calDayRemindersSection: "Hatırlatıcılar",
	calOpenProfile: "Profili aç",
	calPeopleLabel: "Kişiler:",
	calReminders: "Hatırlatıcılar",
	calRemindersLabel: "Hatirlaticilar:",
	calAttendanceLabel: "Devam:",
	calSecurityLabel: "Güvenlik:",
	calSecurityAlerts: "Uyarılar",
	calSecuritySessions: "Oturumlar",
	calSecurityTokenExpiry: "Token Süresi Dolumu",
	calRemindersToggle: "Aktif hatirlaticilar",
	calSave: "Kaydet",
	calSaveFailed: "Kayıt başarısız",
	calShareWithUsers: "Kullanıcılarla paylaş",
	calShareWithUsersPh: "Kişi arayın ve seçin",
	calStart: "Başlangıç",
	calStartEndRequired: "Başlangıç ve bitiş gerekli",
	calStartTime: "Başlangıç saati",
	calSwalDelete: "Sil",
	calTaskHigh: "Yüksek",
	calTaskLow: "Düşük",
	calTaskMedium: "Orta",
	calTaskUrgent: "Acil",
	calTasksLabel: "Görevler:",
	calTicketsLabel: "Ticketler:",
	calToday: "Bugün",
	calUserFallback: "Kullanıcı",
	calWeek: "Hafta",
	calculatePayroll: "Bordroyu hesapla",
	calculated: "Hesaplandı",
	calculations: "Hesaplamalar",
	calendarEventType: "Takvim etkinliği",
	calling: "Arama",
	cancel: "İptal et",
	clearText: "Metni temizle",
	cancelAction: "Eylemi İptal Et",
	cancelBack: "Geri İptal",
	cancelled: "İptal Edildi",
	cannotBeUndone: "Bu işlem geri alınamaz.",
	cannotPayOnline: "Online ödeme yapılamaz",
	cart: "Çalışanlar",
	categories: "Kategoriler",
	category: "Kategori",
	categoryPerformance: "Kategori Performansı",
	certificate: "Sertifika",
	certificateImages: "Sertifika Resimleri",
	certificates: "Sertifikalar",
	changedDate: "Değişiklik Tarihi",
	channel: "Kanal",
	channelWritePermissionDescription: "Mesaj yazma yetkisi yalnizca sohbet yoneticilerindedir",
	channels: "Kanallar",
	charts: "Grafikler",
	chatActions: "sohbet eylemleri",
	chatActiveLabel: "aktif...",
	chatAddOption: "Secenek ekle",
	chatAddUsers: "Kullanici ekle",
	chatAddedToGroupNotification: "Grup sohbetine eklendiniz",
	chatAddedYouToGroup: "sizi suhbete ekledi:",
	chatAudioCall: "sesli arama",
	chatBulkDeleteFailed: "Toplu silme basarisiz.",
	chatBulkForwardFailed: "Toplu iletme basarisiz.",
	chatCallMessage: "Arama mesaji",
	chatChoosingEmoji: "emoji seciyor...",
	chatClickMapToChoosePoint: "Ozel bir nokta secmek icin haritaya tiklayin.",
	chatCoordinatesUnavailable: "Koordinatlar kullanilamiyor",
	chatCopyCoordinates: "Koordinatlari kopyala",
	chatCopyCoordinatesFailed: "Koordinatlar kopyalanamadi.",
	chatCreatePoll: "Anket olustur",
	chatCurrent: "Mevcut",
	chatCurrentLocation: "Mevcut konum",
	chatDashboard: "Sohbet Panosu",
	chatDeleteFailed: "Silme basarisiz",
	chatDeleteForMeOnly: "Sadece benim icin sil",
	chatDeleteForParticipants: "Katilimcilar icin de sil",
	chatDeleteLocation: "Konumu sil",
	chatDeleteSelectedMessagesDescription:
		"Bu islem secilen mesajlari sohbet gorunumunuzden kaldirir. Mevcut izinlerle silinemeyen mesajlar basarisiz olarak bildirilecektir.",
	chatDeleteSelectedMessagesTitle: "Secilen mesajlari sil",
	chatDeletionPartialWarning:
		"Bazi mesajlar zaten silinmisse veya izin kontrolleri basarisiz olursa silme sonuclari kismi olabilir.",
	chatDepartmentSaveFailed: "Departman guncellenemedi",
	chatDepartmentSaveFailedTryAgain: "Lutfen departmani tekrar guncellemeyi deneyin.",
	chatDeselectAllMessages: "Secimi kaldir",
	chatDestinationChatsLabel: "Hedef sohbetler",
	chatDestinationChatsPlaceholder: "Bir veya daha fazla sohbet secin",
	chatDirect: "Doğrudan Sohbet",
	chatDirectChat: "Direkt sohbet",
	chatEditFailed: "Mesaj duzenlenemedi",
	chatEditFailedTryAgain: "Lutfen yeniden duzenlemeyi deneyin.",
	chatEditMessagePlaceholder: "Mesaji duzenle...",
	writeMessage: "Mesaj yazın...",
	chatEditingMessage: "Mesaj duzenleniyor",
	chatExitSelectionMode: "Seçim modundan çık",
	chatExpired: "Suresi doldu",
	chatForwardFailed: "Iletme basarisiz",
	chatForwardSelectedMessagesTitle: "Secilen mesajlari ilet",
	chatForwardableLabel: "iletilebilir",
	chatGeolocationUnavailable: "Bu tarayicida konum servisi kullanilamiyor.",
	chatGroupChat: "grup sohbeti",
	chatGroupInfo: "Grup bilgisi",
	chatGroupMembers: "Grup uyeleri",
	chatGroupSettings: "Grup ayarlari",
	chatGroupSettingsDescription: "Grup goruntusunu ve bagli IK departmanini ayarlayin",
	chatID: "Sohbet ID",
	chatImageUploadFailed: "Gorsel yukleme basarisiz",
	chatImageUploadFailedTryAgain: "Lutfen farkli bir gorsel yuklemeyi deneyin.",
	chatIncludeLabel: "Dahil et",
	chatIsChoosingEmoji: "emoji seciyor...",
	chatIsTyping: "yaziyor...",
	chatLastUpdated: "Son guncelleme",
	chatLatitude: "Enlem",
	chatLive: "Canli",
	chatLiveFor: "Canli suredir",
	chatLiveLocation: "Canli konum",
	chatLiveLocationOptInWarning:
		"Canli konum acik onay gerektirir ve istediginiz zaman durdurulabilir.",
	chatLiveLocationSharingActive: "Canli konum paylasimi aktif",
	chatLoadingLocation: "Konum yukleniyor...",
	chatLoadingPoll: "Anket yukleniyor...",
	chatLongitude: "Boylam",
	chatMessagesCannotBeForwarded: "mesaj iletilemez ve atlanacaktir.",
	chatMessagesDeleted: "Mesajlar silindi",
	chatMessagesForwarded: "Mesajlar iletildi",
	chatMoreActions: "Daha fazla eylem",
	chatNoAvailableUsersToAdd: "Mevcut tum kullanicilar zaten bu grupta.",
	chatNoBackground: "Arka plan yok",
	chatNoChatsFound: "Sohbet bulunamadi",
	chatNoMessagesForwarded: "Hicbir mesaj iletilemedi.",
	chatNoSelectedMessagesDeleted: "Secilen mesajlardan hicbiri silinemedi.",
	chatOpenDepartmentPage: "Departman sayfasini ac",
	chatOpenMap: "Haritayi ac",
	chatOptionalAddressLabel: "Istege bagli adres etiketi",
	chatOwnMessagesLabel: "kendi",
	chatPartialDelete: "Kismi silme",
	chatPartialForward: "Kismi iletme",
	chatPattern: "Desen",
	chatPickOnMap: "Haritada sec",
	chatPickPointOnMap: "Haritada bir nokta secin.",
	chatPinnedLocation: "Sabitlenmis konum",
	chatPollAddAnotherOption: "Baska bir secenek ekle",
	chatPollAddOptionFailed: "Secenek eklenemedi.",
	chatPollAllowAddingOptions: "Secenek eklemeye izin ver",
	chatPollAllowMultipleAnswers: "Coklu cevaba izin ver",
	chatPollAllowRevote: "Yeniden oylamaya izin ver",
	chatPollAnonymous: "Anonim anket",
	chatPollAnonymousCannotAddOptions: "Anonim testte secenek ekleme acilamaz.",
	chatPollAtLeastOptions: "En az secenek gerekli:",
	chatPollAutoClose: "Otomatik kapanis",
	chatPollChangeVote: "Oyu degistir",
	chatPollChooseCorrectAnswer: "Test icin en az bir dogru cevap secin.",
	chatPollCloseDate: "Kapanis tarihi",
	chatPollCloseDateOrOpenPeriod: "Kapanis tarihi veya sure kullanin, ikisini birden degil.",
	chatPollCloseFailed: "Anket kapatilamadi.",
	chatPollClosePoll: "Anketi kapat",
	chatPollCorrectAnswer: "Dogru cevap",
	chatPollCorrectAnswers: "Dogru cevaplar",
	chatPollCreateFailed: "Anket olusturulamadi.",
	chatPollDeletePoll: "Anketi sil",
	chatPollDescriptionMax: "Aciklama en fazla",
	chatPollExplanationMax: "Aciklama metni en fazla",
	chatPollHideResultsUntilClosed: "Sonuclari kapanana kadar gizle",
	chatPollIncorrectAnswer: "Yanlis cevap",
	chatPollLeaveEmptyKeepOpen: "Acik birakmak icin bos birakin",
	chatPollLeaveEmptyNoTimer: "Zamanlayici istemiyorsaniz bos birakin",
	chatPollLoadVotersFailed: "Oy verenler yuklenemedi.",
	chatPollMultipleChoice: "Coktan secmeli",
	chatPollNewOption: "Yeni secenek",
	chatPollNoVoteYet: "Henuz oy yok",
	chatPollNoVotersForOption: "Bu secenek icin oy veren yok.",
	chatPollOpenPeriod: "Acik kalma suresi",
	chatPollOptionMax: "Secenek en fazla",
	chatPollOptionRequired: "Secenek zorunludur.",
	chatPollOptionsUnique: "Secenekler benzersiz olmali.",
	chatPollPublic: "Herkese acik",
	chatPollQuestionMax: "Soru en fazla",
	chatPollQuestionRequired: "Soru zorunludur.",
	chatPollQuiz: "Test",
	chatPollQuizExplanation: "Test aciklamasi",
	chatPollRegular: "Normal",
	chatPollResultsHiddenUntilClosed: "Anket kapanana kadar sonuclar gizlidir.",
	chatPollSearchVoters: "Oy verenlerde ara",
	chatPollShuffleOptions: "Secenekleri karistir",
	chatPollSingleChoice: "Tek secim",
	chatPollSingleChoiceOneCorrect: "Tek secimli testte yalnizca bir dogru cevap olabilir.",
	chatPollSubmitVoteFailed: "Oyunuz gonderilemedi.",
	chatPollViewVoters: "Oy verenleri gor",
	chatPollVoteRecorded: "Oy kaydedildi",
	chatPollVotersLabel: "oy veren",
	chatPollVotersTitle: "Oy verenler",
	chatPollYouVoted: "Oy verdiniz.",
	chatPollYouVotedCanChange: "Oy verdiniz ve cevabinizi degistirebilirsiniz.",
	chatPreviewChronological: "Onizleme (kronolojik)",
	chatProvider: "Saglayici",
	chatReadCurrentLocationFailed: "Guncel konumunuz alinamadi.",
	chatRefreshCurrentLocation: "Mevcut konumu yenile",
	chatRuleAllow: "Evet",
	chatRuleDeny: "Hayir",
	chatRuleTimed: "Evet, sinirli sureyle",
	chatRuleTimerDescription: "Ornek: 1 yazarsaniz islem yalnizca ilk dakika icinde izinli olur.",
	chatRuleTimerMinutes: "Dakika zamanlayici",
	chatSearchMessage: "Mesaj ara",
	chatSelectAllMessages: "Tumunu sec",
	chatSelectDepartment: "IK departmanini secin",
	chatSelectOrLoadLocationFirst: "Once bir konum secin veya yukleyin.",
	chatSelectRepeatingBackground: "Tekrarlayan arka plan secin",
	chatSelectUsersToAdd: "Eklenecek kullanicilari secin",
	chatSelectedLabel: "secili",
	chatSelectionMode: "Secim modu",
	chatSendCurrentLocation: "Mevcut konumu gonder",
	chatSendLocationFailed: "Konum gonderilemedi.",
	chatSendPinnedLocation: "Sabitlenmis konumu gonder",
	chatSendVenue: "Mekani gonder",
	chatSentAt: "Gonderildi",
	chatSettings: "Sohbet ayarlari",
	chatSettingsEditRule: "Mesaj Duzenleme",
	chatSettingsEditRuleDescription:
		"Gonderilen mesajlarin her zaman, hicbir zaman veya sinirli sureyle duzenlenmesini secin.",
	chatSettingsForwardRule: "Mesaj Iletme",
	chatSettingsForwardRuleDescription:
		"Iletmeyi her zaman, hicbir zaman veya belirli bir sure ile sinirlayin.",
	chatSettingsGlobalPageSubtitle:
		"Kisisel sohbet kurallarini burada bir kez ayarlayin. Grup kurallarini yalnizca grup yoneticileri degistirebilir.",
	chatSettingsGlobalPageTitle: "Genel Sohbet Ayarlari",
	chatSettingsGlobalRulesDescription:
		"Bu kurallar tum kisisel sohbetlerde gecerlidir.",
	chatSettingsGlobalSavedSuccess: "Genel sohbet ayarlari basariyla guncellendi",
	chatSettingsCompactMode: "Kompakt mod",
	chatSettingsCompactModeDescription:
		"Kenar cubuguna daha fazla sohbet sigmasi icin bosluklari ve avatar boyutunu azaltin.",
	chatSettingsSidebarDescription: "Sohbetlerin sol kenar cubugunda nasil goruntulenecegini kontrol edin.",
	chatSettingsSidebarTitle: "Sohbet Kenar Cubugu",
	chatSettingsShowLastMessage: "Son mesaji goster",
	chatSettingsShowLastMessageDescription:
		"Sohbet kenar cubugunda son mesaj onizlemesini ve tarihini veya saatini gosterin.",
	chatSettingsReplyRule: "Mesajlara Yanit",
	chatSettingsReplyRuleDescription:
		"Yanitlamayi her zaman, hicbir zaman veya belirli bir zaman araliginda izin verin.",
	chatSettingsResetToGlobal: "Grup varsayilanlarini geri yukle",
	chatSettingsRulesAdminOnly: "Bu kurallari yalnizca sohbet yoneticileri degistirebilir.",
	chatSettingsRulesDescription: "Iletme, yanitlama ve duzenleme icin genel kurallari ayarlayin.",
	chatSettingsRulesTitle: "Sohbet Kurallari",
	chatSettingsSaveFailed: "Sohbet ayarlari kaydedilemedi",
	chatSettingsSaveFailedTryAgain: "Lutfen tekrar deneyin.",
	chatSettingsUsingCustomRules:
		"Bu grup yoneticilerin belirledigi kurallari kullaniyor.",
	chatSettingsUsingGlobalRules: "Bu grup varsayilan kurallari kullaniyor.",
	chatShareLocation: "Konum paylas",
	chatSkipLabel: "Atla",
	chatSkippedLabel: "atlanan",
	chatStartCall: "Aramayi baslat",
	chatStartLiveSharing: "Canli paylasimi baslat",
	chatStopLiveSharing: "Canli paylasimi durdur",
	chatType: "Sohbet Türü",
	chatTypeToSearch: "Aramak icin yazin",
	chatTyping: "yaziyor...",
	chatUnnamedChat: "Isimsiz sohbet",
	chatUpdatingSharedLocationFor: "Bu paylasilan konum guncelleniyor",
	chatUploadGroupImage: "Grup gorseli yukle",
	chatUserInfo: "Kullanici bilgisi",
	chatUsersSaveFailed: "Kullanicilar eklenemedi",
	chatUsersSaveFailedTryAgain: "Lutfen secilen kullanicilari tekrar eklemeyi deneyin.",
	chatVenue: "Mekan",
	chatVenueTitle: "Mekan basligi",
	chatVideoCall: "goruntulu arama",
	chatViewReportedMessages: "Bildirilen mesajlari gor",
	chatWaitingDeviceCoordinates: "Cihaz koordinatlari bekleniyor...",
	childcarePayment: "Çocuk bakımı ödemesi",
	chooseBoard: "Board seçerek onun kategorilerini ve görevlerini görüntüleyebilirsiniz",
	cities: "Şehirler",
	city: "Şehir",
	clear: "Temizle",
	clearFilters: "Filtreleri temizle",
	clickTheButtonBelowToTakeTheNextStepOnYourJourney:
		"Yolculuğunuzda bir sonraki adımı atmak için aşağıdaki düğmeye tıklayın",
	contact: "Müşteri",
	contactEngagement: "Müşteri Katılımı",
	contactGroup: "Müşteri Grubu",
	contactGroups: "Müşteri Grupları",
	contactPlaylist: "İstemci çalma listesi",
	contactProfile: "Müşteri profili",
	contacts: "müşteriler",
	contactsByGender: "Cinsiyete Göre Müşteriler",
	contactsByGroup: "Gruba Göre Müşteriler",
	contactsUsing: "kullanan müşteriler",
	contactsWithCarts: "Sepeti Olan Müşteriler",
	contactsWithFavorites: "Favorileri Olan Müşteriler",
	clockInOut: "Giriş / Çıkış",
	close: "Kapat",
	closeNavigation: "Gezintiyi kapat",
	closeTicket: "Bileti Kapat",
	closed: "Kapalı",
	closed_late: "Son tarihten sonra kapatıldı",
	closedDate: "Kapanış Tarihi",
	closedTickets: "Kapatılmış Biletler",
	cmDashboard: "CM Panosu",
	code: "Kod",
	coin: "Madeni Para",
	coinBurnTime: "Para yakma zamanı",
	coinCount: "Para sayısı",
	color: "Renk",
	comment: "Yorum",
	commentTicket: "Bilet Yorumları",
	commissions: "Komisyonlar",
	communicationPreferences: "İletişim Tercihleri",
	community: "Topluluk",
	company: "Şirket",
	completed: "Tamamlandı",
	completedDate: "Tamamlanma Tarihi",
	completedTasks: "Tamamlanan görevler",
	completionRate: "tamamlanma oranı",
	confirm: "Onayla",
	confirmAction: "Eylemi Onayla",
	contactForm: "İletişim formu",
	contactForms: "İletişim Formları",
	contactType: "İletişim türü",
	contacts: "İletişim",
	contentByType: "Türe Göre İçerik",
	contentItems: "İçerik Öğeleri",
	contentManagementOverview: "İçerik yönetim sistemi genel bakış",
	contentOverTime: "Zaman İçinde Oluşturulan İçerik (Son 30 Gün)",
	continue: "Devam et",
	contract: "Sözleşme",
	contractEndDate: "Sözleşme Bitiş Tarihi",
	contractStartDate: "Sözleşme Başlangıç Tarihi",
	contractor: "Yüklenici",
	copy: "Kopyala",
	costOfBuildingPart: "Bina kısmının maliyeti",
	costOfBuildingPermit: "İnşaat izni maliyeti",
	country: "Ülke",
	cpu: "CPU",
	create: "Sipariş",
	createBoard: "Yeni bir pano oluştur",
	createChat: "Sohbet Oluştur",
	createGroupChat: "Grup Sohbeti Oluştur",
	createGroupSubmit: "Oluştur",
	addNewCategory: "Yeni kategori ekle",
	createNewCategory: "Yeni bir kategori oluştur",
	created: "Oluşturuldu",
	createdAt: "Oluşturulma Tarihi",
	createdBy: "Oluşturan",
	createdByUser: "Kullanıcı Tarafından Oluşturuldu",
	critical: "Kritik",
	crmDashboard: "CRM Panosu",
	cta1: "Eylem çağrısı bölümü 1",
	cta2: "Eylem çağrısı bölümü 2",
	cta3: "Eylem çağrısı bölümü 3",
	currency: "Para",
	currentlyStreaming: "şu anda yayınlanıyor",
	currentlyWorking: "Şu anda çalışıyor",
	custom: "Özel",
	customerAcquisition: "Müşteri Kazanımı",
	customerBaseOverview: "Müşteri Tabanı Genel Bakış",
	customerInsights: "Müşteri İçgörüleri",
	customerRelationshipOverview: "Müşteri ilişkileri yönetimi genel bakış",
	dashboard: "Gösterge Paneli",
	dashboardSubtitle: "Kontrol Paneli Alt Başlığı",
	database: "Veritabanı",
	date: "Tarih",
	dateOfBirth: "Doğum Tarihi",
	dates: "Tarihler",
	datingAttendance: "Randevu Katılımı",
	dayOff: "İzin günü",
	meeting: "Toplantı",
	dayOffForAllEmployees: "Tüm çalışanlar için izin günü",
	dayOffRemoved: "İzin günü kaldırıldı",
	dayOffSavedForAllEmployees: "İzin günü tüm çalışanlar için kaydedildi",
	days: "gün",
	daysLeft: "gün kaldı",
	daysOfWeek: "Haftanın günleri",
	daysWorked: "Calisilan gunler",
	deadLine: "Son Tarih",
	deadline: "Son Tarih",
	debt: "Borç",
	decline: "Reddet",
	deductions: "Kesintiler",
	defaultEnergyMax: "Varsayılan enerji maksimum",
	defaultEnergyMin: "En az enerji",
	defaultStream: "Varsayılan Akış",
	defaultStreams: "Varsayılan Akışlar",
	defaultStreamsDesc: "varsayılan akışlar",
	delays: "Gecikmeler",
	delete: "Sil",
	deleteForEveryone: "Herkes için sil",
	deletePermanently: "Kalıcı Olarak Sil",
	deleteRule: "Kuralı sil",
	deleteSelected: "Seçilenleri sil",
	delivery: "Teslimat",
	deliveryAddress: "Teslimat Adresi",
	deliveryMethod: "Teslimat Yöntemi",
	density: "Yoğunluk",
	department: "Bölüm",
	departmentChatsHelp:
		"Grup ve kanal sohbetlerini bu departmana bağlayın. Her sohbetin departman alanı ile senkron kalır.",
	departmentLinkedChats: "Departman sohbetleri",
	departments: "Bölümler",
	desc: "Açıklama",
	description: "Açıklama",
	designer: "Tasarımcı",
	detailedFilters: "Detaylı filtreler",
	detailedSteps: "Ayrıntılı Adımlar",
	details: "Detaylar",
	developed: "Geliştirilmiş",
	developedBy: "Geliştirici",
	difference: "Fark",
	diplomaImages: "Diploma resimleri",
	directMessages: "Doğrudan Mesajlar",
	disableSteps: "Adımları devre dışı bırak",
	disabledSteps: "Devre dışı bırakılan adımlar",
	disk: "Disk",
	distributionByPaymentType: "Ödeme Türüne Göre Dağılım",
	domainFacility: "Tesis",
	domainFinance: "Finans",
	domainHR: "İK",
	domainIT: "IT",
	domainOther: "Diğer",
	domainSecurity: "Güvenlik",
	done: "Tamamlandı",
	download: "İndir",
	downloadAsContact: "Kişi olarak indir",
	draft: "Taslak",
	dragToReorder: "Sıralamayı değiştirmek için sürükleyin",
	dropFilesHere: "Dosyaları buraya sürükleyin",
	dropFilesHereOrClick: "Dosyaları buraya sürükleyin veya daha fazla eklemek için tıklayın",
	dropzoneText: "Görüntüleri buraya sürükleyin veya dosya seçmek için tıklayın",
	dueDate: "Teslim Tarihi",
	duration: "Süre",
	ecommerceDashboard: "E-ticaret Panosu",
	edit: "Düzenle",
	editComment: "Yorumu düzenle",
	editItem: "Öğeyi Düzenle",
	editProject: "Projeyi düzenle",
	editRule: "Kuralı düzenle",
	edited: "Düzenlendi",
	editingRule: "Kuralı düzenle",
	email: "E-posta",
	sendEmail: "E-posta gönder",
	employee: "Çalışan",
	employeesPerDepartment: "Departman başına çalışanlar",
	employerExpenses: "İşveren giderleri",
	employmentStatus: "İstihdam Durumu",
	emptyTrash: "Çöp kutusunu temizle",
	end: "Son",
	endDate: "Bitiş Tarihi",
	endDateMustBeLaterThanStartDate: "Bitiş tarihi başlangıç tarihinden sonra olmalıdır",
	endDateShort: "Bitiş Tarihi",
	endOfTraining: "Eğitimin sonu",
	endTime: "Bitiş saati",
	ends: "Biter",
	energyLevel: "Enerji seviyesi",
	energyScheduling: "Enerji planlaması",
	enterAmount: "Miktar gir",
	enterFeatureSuffix: "Özellik soneki gir",
	enterFeatureText: "Özellik metni gir",
	enterGroupName: "Grup adını girin...",
	enterLabel: "Etiket gir",
	enterPersons: "Kişi sayısı gir",
	enterRuleName: "Kural adı gir",
	entry: "Giriş",
	error: "Hata",
	errorMessage: "Bir hata oluştu, lütfen tekrar deneyin.",
	errorOccurred: "Bir hata oluştu",
	errorPageButton: "Beni eve götür",
	errorPageHelpText: "Yardıma mı ihtiyacınız var? Destek ekibimizle iletişime geçin",
	errorPageSecondaryButton: "Bu sorunu bildir",
	errorPageSubtitle: "Aradığınız sayfa mevcut değil",
	errorPageText:
		"Endişelenmeyin, en iyilerimizin başına gelir! Sayfa taşınmış, silinmiş olabilir veya yanlış URL girmiş olabilirsiniz. Sizi doğru yola geri döndürelim.",
	errorPageTitle: "Hay aksi! Bir şeyler ters gitti",
	errorUserNotFound: "Kullanıcı bulunamadı",
	estimatedHours: "Tahmini Saat",
	eventType: "Etkinlik türü",
	exit: "Çıkış",
	expectedSalary: "Beklenen Maaş",
	expireDate: "Son Kullanma Tarihi",
	expired: "Süresi dolmuş",
	expiresOn: "Son kullanma tarihi",
	expiringIdCards: "Süresi Dolan Kimlik Kartları",
	expiringPassports: "Süresi Dolan Pasaportlar",
	export: "Dışa aktar",
	exportData: "Veri Dışa Aktar",
	extraLarge: "Çok Büyük",
	extraSmall: "Çok Küçük",
	faqQuestions: "SSS Soruları",
	favorites: "Favoriler",
	features: "Özellikler",
	female: "Kadın",
	fields: "Alanlar",
	file: "Dosya",
	fileHasBeenRemoved: "Dosya kaldırıldı",
	fileMovedToTrash: "Dosya çöp kutusuna taşındı",
	fileRestored: "Dosya geri alındı",
	fileWillBeMovedToTrash: "Dosya çöp kutusuna taşınacak",
	files: "Dosyalar",
	filesRestored: "Dosyalar geri alındı",
	filesWillBePermanentlyDeleted: "dosya kalıcı olarak silinecek.",
	filter: "Filtre",
	filterBy: "Filtre",
	filters: "Filtreler",
	finish: "Bitir",
	fired: "Kovuldu",
	firstIn: "İlk giriş",
	firstName: "Ad",
	forgotPassword: "Şifrenizi mi unuttunuz?",
	forward: "İlet",
	forwardMessage: "Mesajı ilet",
	forwarded: "İletildi",
	forwardedFrom: "Şuradan iletildi",
	fri: "Cuma",
	from: "Den",
	fromAttendanceLogs:
		"Bu çalışan ve dönem için devam kayıtlarından doldurulur; düzenleyebilirsiniz.",
	fromDb: "Veritabanından",
	fromHrSettings: "İK ayarları",
	gallery: "Galeri",
	genderDistribution: "Cinsiyet Dağılımı",
	globalFilter: "Genel filtre",
	globalSearchClose: "Kapat",
	globalSearchCmd_goCalendar_desc: "Takvim etkinlikleri",
	globalSearchCmd_goCalendar_label: "Takvime git",
	globalSearchCmd_goChat_desc: "Mesajlaşmayı aç",
	globalSearchCmd_goChat_label: "Sohbete git",
	globalSearchCmd_goCrm_desc: "Müşteri yönetimi",
	globalSearchCmd_goCrm_label: "CRM'e git",
	globalSearchCmd_goFinance_desc: "Finans modülü",
	globalSearchCmd_goFinance_label: "Finansa git",
	globalSearchCmd_goHr_desc: "İnsan kaynakları modülü",
	globalSearchCmd_goHr_label: "İK'ye git",
	globalSearchCmd_goIt_desc: "BT ekipmanı",
	globalSearchCmd_goIt_label: "BT'ye git",
	globalSearchCmd_goProjects_desc: "Proje veritabanı",
	globalSearchCmd_goProjects_label: "Projelere git",
	globalSearchCmd_goRadio_desc: "Müzik ve çalma listeleri",
	globalSearchCmd_goRadio_label: "Radyoya git",
	globalSearchCmd_goTickets_desc: "Destek talep sistemi",
	globalSearchCmd_goTickets_label: "Taleplere git",
	globalSearchCmd_goTodo_desc: "Panolar ve görevler",
	globalSearchCmd_goTodo_label: "Yapılacaklara git",
	globalSearchCmd_messageUser_desc: "Mesaj göndermek için sohbet aç",
	globalSearchCmd_messageUser_label: "Kullanıcıya mesaj",
	globalSearchCmd_newContact_desc: "CRM müşterisi ekle",
	globalSearchCmd_newClient_label: "Yeni müşteri",
	globalSearchCmd_newOrder_desc: "Sipariş oluştur",
	globalSearchCmd_newOrder_label: "Yeni sipariş",
	globalSearchCmd_newProject_desc: "Proje oluştur",
	globalSearchCmd_newProject_label: "Yeni proje",
	globalSearchCmd_newTask_desc: "Görev oluştur",
	globalSearchCmd_newTask_label: "Yeni görev",
	globalSearchCmd_newTicket_desc: "Destek talebi oluştur",
	globalSearchCmd_newTicket_label: "Yeni talep",
	globalSearchCommandBadge: "Komut",
	globalSearchCommands: "Komutlar",
	globalSearchCopied: "Kopyalandı!",
	globalSearchCopyLink: "Bağlantıyı kopyala",
	globalSearchDirectMessage: "Direkt mesaj",
	globalSearchFilterAll: "Tümü",
	globalSearchFilterCalendar: "Takvim",
	globalSearchFilterChats: "Sohbetler",
	globalSearchFilterDevices: "Cihazlar",
	globalSearchFilterEcom: "E-ticaret",
	globalSearchFilterFinance: "Finans",
	globalSearchFilterPeople: "Kişiler",
	globalSearchFilterProjects: "Projeler",
	globalSearchFilterRadio: "Radyo",
	globalSearchFilterTickets: "Talepler",
	globalSearchFilterTodo: "Yapılacaklar",
	globalSearchHidePreview: "Önizlemeyi gizle",
	globalSearchNavigate: "Gezin",
	globalSearchOpen: "Aç",
	globalSearchOpenInNewTab: "Yeni sekmede aç",
	globalSearchPageBadge: "Sayfa",
	globalSearchPlaceholder: "APIT içinde ara (kullanıcılar, talepler, sohbetler, cihazlar…)",
	globalSearchPreviewAddress: "Adres",
	globalSearchPreviewArtist: "Sanatçı",
	globalSearchPreviewChat: "Sohbet",
	globalSearchPreviewCompany: "Şirket",
	globalSearchPreviewCreated: "Oluşturuldu",
	globalSearchPreviewDeviceId: "Cihaz ID",
	globalSearchPreviewEmail: "E-posta",
	globalSearchPreviewEmployeeNumber: "Personel no.",
	globalSearchPreviewEnd: "Bitiş",
	globalSearchPreviewInfo: "Bilgi",
	globalSearchPreviewIp: "IP",
	globalSearchPreviewLocation: "Konum",
	globalSearchPreviewMac: "MAC",
	globalSearchPreviewNumber: "Numara",
	globalSearchPreviewOrderNumber: "Sipariş no.",
	globalSearchPreviewPhone: "Telefon",
	globalSearchPreviewSent: "Gönderildi",
	globalSearchPreviewStart: "Başlangıç",
	globalSearchPreviewUsername: "Kullanıcı adı",
	globalSearchPreviewVendor: "Tedarikçi",
	globalSearchPreviewVersion: "Sürüm",
	globalSearchRecentSearches: "Son aramalar",
	globalSearchRecentlyOpened: "Son açılanlar",
	globalSearchSectionArtists: "Sanatçılar",
	globalSearchSectionAttendanceDevices: "Puantaj cihazları",
	globalSearchSectionBrands: "Markalar",
	globalSearchSectionCalendarEvents: "Takvim etkinlikleri",
	globalSearchSectionCameras: "Kameralar",
	globalSearchSectionChats: "Sohbetler",
	globalSearchSectionClientGroups: "Müşteri grupları",
	globalSearchSectionClients: "Müşteriler",
	globalSearchSectionCpus: "İşlemciler",
	globalSearchSectionDepartments: "Departmanlar",
	globalSearchSectionEcomCategories: "Kategoriler",
	globalSearchSectionFinanceCardIssuers: "Kart çıkaran kuruluşlar",
	globalSearchSectionFinanceCards: "Kartlar",
	globalSearchSectionFinanceCategories: "Finans kategorileri",
	globalSearchSectionFinanceTransactions: "İşlemler",
	globalSearchSectionGpus: "GPU'lar",
	globalSearchSectionKeyboards: "Klavyeler",
	globalSearchSectionLaptops: "Dizüstü bilgisayarlar",
	globalSearchSectionMessages: "Mesajlar",
	globalSearchSectionMice: "Fareler",
	globalSearchSectionMonitors: "Monitörler",
	globalSearchSectionOrders: "Siparişler",
	globalSearchSectionPcs: "Bilgisayarlar",
	globalSearchSectionPlaylists: "Çalma listeleri",
	globalSearchSectionPositions: "Pozisyonlar",
	globalSearchSectionPrinters: "Yazıcılar",
	globalSearchSectionProblems: "Sorunlar",
	globalSearchSectionProducts: "Ürünler",
	globalSearchSectionProjects: "Projeler",
	globalSearchSectionRams: "RAM",
	globalSearchSectionRoms: "Depolama",
	globalSearchSectionRooms: "Odalar",
	globalSearchSectionRouters: "Yönlendiriciler",
	globalSearchSectionSmbs: "SMB",
	globalSearchSectionSoftware: "Yazılım",
	globalSearchSectionSwitches: "Anahtarlar",
	globalSearchSectionTelephones: "Telefonlar",
	globalSearchSectionTickets: "Talepler",
	globalSearchSectionTodoBoards: "Panolar",
	globalSearchSectionTodoCategories: "Kategoriler",
	globalSearchSectionTodoTasks: "Görevler",
	globalSearchSectionTracks: "Parçalar",
	globalSearchSectionUsers: "Kişiler",
	globalSearchSectionWarrantyProviders: "Garanti sağlayıcıları",
	globalSearchSelectPreview: "Önizleme için bir öğe seçin",
	globalSearchShortcutHint: "Ctrl + K",
	globalSearchShowPreview: "Önizlemeyi göster",
	globalSearchSubtitle: "Tüm modüllerde ara",
	globalSearchSuggest1: "Bana atanan talepleri ara",
	globalSearchSuggest2: "E-posta ile çalışan bul",
	globalSearchSuggest3: "Sohbet mesajlarında ara",
	globalSearchSuggest4: "IP ile cihaz bul",
	globalSearchSuggest5: "Telefonla müşteri ara",
	globalSearchSuggest6: "Projelere git",
	globalSearchTrySearchingFor: "Şunu aramayı deneyin",
	goBack: "Geri Dön",
	goToMessage: "Mesaja git",
	goToUserAttendanceTab: "Kullanıcılar → puantaj",
	goToUserAttendanceTabTooltip: "Bu çalışanı İK Kullanıcılar sayfasında Puantaj sekmesinde aç",
	gpu: "GPU",
	grossSalary: "Brüt maaş",
	group: "Grup",
	groupChat: "Grup Sohbeti",
	groupChatWritePermissionDescription: "Sohbetteki herkes mesaj yazabilir",
	groupChats: "Grup Sohbetleri",
	groupName: "Grup Adı (İsteğe bağlı)",
	healthInsurance: "Sağlık sigortası",
	healthInsuranceBenefit: "Sağlık sigortası (yan hak)",
	help: "Yardım",
	hideAllSteps: "Tüm adımları gizle",
	hideHistory: "Tarihi gizle",
	hideProjectDetails: "Proje ayrıntılarını gizle",
	hideTableColumnFilters: "Sütun filtrelerini gizle",
	hideTimeline: "Zaman çizelgesini gizle",
	high: "Yüksek",
	highestSpendingCustomers: "En Çok Harcama Yapan Müşteriler",
	highlight: "Vurgula",
	highlightFeature: "Özellik vurgula",
	history: "Geçmiş",
	historyTable: "Geçmiş tablosu",
	holiday: "Resmi tatil",
	holidayNonWorking: "Tatil / çalışılmayan gün",
	hourlyRate: "Saatlik ücret",
	hourlyRateBaseLinked:
		"Normal saatler > 0 iken temel maaşı saatlik ücret × normal saatlerden günceller.",
	hr2025RateReferenceTables: "2025 oran referans tabloları",
	hrAccrualAnnualTotal: "Yıllık toplam: {amount} gün",
	hrAccrualDaily: "Günlük (÷ 365)",
	hrAccrualEachDay: "Her gün: +{amount} izin günü",
	hrAccrualEachMonthFirst: "Her ayın 1'i: +{amount} izin günü",
	hrAccrualMethod: "Tahakkuk yöntemi",
	hrAccrualMethodDesc: "Yıllık iznin nasıl biriktiği",
	hrAccrualMonthly: "Aylık (÷ 12, ayın 1'inde)",
	hrAccrualMonthlyEquivalent: "Aylık karşılığı: ~{amount} gün",
	hrAccrualPreview: "Tahakkuk önizlemesi",
	hrArmeniaIncomeTaxCalculator: "Ermenistan gelir vergisi hesaplayıcı",
	hrArmeniaTaxRates: "Ermenistan vergi oranları",
	hrCalcSummaryGrossToNet:
		"{gross} AMD kayıtlı maaş için, {deductions} AMD vergi ve kesintiden sonra elinize {net} AMD geçer.",
	hrCalcSummaryNetToGross: "Elinize {net} AMD geçmesi için sözleşmede brüt {gross} AMD olmalıdır.",
	hrCalculationBreakdown: "Hesaplama dökümü",
	hrCalculationDirection: "Hesaplama yönü",
	hrDefaultBenefitsDescription:
		"Bu varsayılanlar, çalışan bazında geçersiz kılınmadıkça tüm bordro hesaplarına uygulanır.",
	hrDefaultMonthlyBenefits: "Varsayılan aylık yan haklar (AMD)",
	hrDesiredNetSalaryLabel: "İstenen net maaş (elde edilecek tutar)",
	hrEmployeePensionLabel: "Çalışan emeklilik kesintisi:",
	hrEmployeePensionRate: "Çalışan emeklilik kesintisi oranı",
	hrEmployeePensionRateDesc: "1973 sonrası doğanlar için zorunlu (%2,5)",
	hrEmployerPensionRate: "İşveren emeklilik payı oranı",
	hrEmployerPensionRateDesc: "İşveren emeklilik katkısı (%2,5)",
	hrFailedToSaveSettings: "Ayarlar kaydedilemedi",
	hrGrossSalaryAMD: "Brüt maaş (AMD)",
	hrGrossSalaryDescription: "İş sözleşmenizde yazılı tutarı girin",
	hrGrossSalaryLabel: "Brüt maaş (kayıtlı / sözleşme tutarı)",
	hrGrossSalaryRegistered: "Brüt maaş (kayıtlı)",
	hrGrossToNet: "Brüt → Net",
	hrHealthInsuranceAges: "Sağlık sigortası (18–65 yaş)",
	hrHealthInsuranceBenefit: "Sağlık sigortası",
	hrHealthInsuranceBenefitDesc: "İşverenin aylık sağlık sigortası katkısı (AMD)",
	hrHealthInsuranceEmployeeColumn: "Çalışan",
	hrHealthInsuranceEmployeeShare: "Sağlık sigortası (çalışan payı)",
	hrHealthInsuranceStateColumn: "Devlet",
	hrITSector: "BT sektörü (%10 gelir vergisi)",
	hrITSectorDesc: "Lisanslı BT şirketi çalışanı",
	hrIncomeTax: "Gelir vergisi",
	hrIncomeTaxLabel: "Gelir vergisi:",
	hrIncomeTaxRate: "Gelir vergisi oranı",
	hrIncomeTaxRateDesc: "Ermenistan'da 2020'den beri düz %20",
	hrLeaveAccrualConfiguration: "İzin birikimi yapılandırması",
	hrLiveRates: "Güncel oranlar",
	hrLunchCoverage: "Yemek yardımı",
	hrLunchCoverageDesc: "Aylık yemek/ gıda yardımı (AMD)",
	hrMandatoryHealthInsurance: "Zorunlu sağlık sigortası (18–65)",
	hrMandatoryHealthInsuranceDesc: "2025 sağlık sigortası kademelerini dahil et",
	hrMilitaryStampRate: "Askeri damga vergisi oranı",
	hrMilitaryStampRateDesc: "Uygulanmıyorsa 0 bırakın",
	hrMonthlyFee: "Aylık ücret",
	hrNetSalaryDescription: "Elinize geçmesini istediğiniz tutarı girin",
	hrNetSalaryLabel: "Net maaş:",
	hrNetSalaryTakeHome: "Net maaş (elde edilen)",
	hrNetToGross: "Net → Brüt",
	hrOvertimeRateMultiplier: "Fazla mesai çarpanı",
	hrOvertimeRateMultiplierDesc: "örn. 1,5× = %50 fazla mesai primi",
	hrOvertimeRules: "Fazla mesai kuralları",
	hrBreakIntervals: "Mola Aralıkları",
	hrBreakIntervalsDesc:
		"Herkes için çalışma saatlerinden hariç tutulan sabit günlük zaman aralıkları (örn. öğle yemeği). Birden fazla ekleyebilirsiniz.",
	hrBreakIntervalsEmpty: "Mola aralığı tanımlanmadı",
	hrBreakIntervalStart: "Mola başlangıcı",
	hrBreakIntervalEnd: "Mola bitişi",
	hrAddBreakInterval: "Mola ekle",
	hrOvertimeThreshold: "Fazla mesai eşiği (saat/gün)",
	hrOvertimeThresholdDesc: "Bunun üzerindeki saatler fazla mesai oranıyla hesaplanır",
	hrPensionMandatory: "Zorunlu / 07/2018 öncesi gönüllü (%5)",
	hrPensionNone: "Katılmayan (%0)",
	hrPensionPost2018: "07/2018 sonrası gönüllü (%5)",
	hrPensionSystem: "Emeklilik sistemi",
	hrPensionSystemDesc: "Birikimli emeklilik katılım durumunuz",
	hrSettingsPageSubtitle: "Bordro, izin ve devam kurallarını yapılandırın",
	hrSettingsPageTitle: "İK Ayarları",
	hrSettingsUpdatedSuccessfully: "İK ayarları başarıyla güncellendi",
	hrSickDaysPerYear: "Yıllık raporlu günler",
	hrSickDaysPerYearDesc: "Takvim yılı başına ücretli hastalık izni günleri",
	hrSocialPaymentPension: "Sosyal ödeme (emeklilik)",
	hrSocialTaxRate: "Sosyal güvenlik vergisi oranı",
	hrSocialTaxRateDesc: "Ermenistan'da şu an %0 (emeklilikle değiştirildi)",
	hrStampFee: "Damga ücreti (Askeri sigorta fonu)",
	hrStampFeeTooltip: "Askeri sigorta fonu — brüt maaş dilimine göre kademeli sabit ücret",
	hrStandardWorkSchedule: "Standart çalışma programı",
	hrStateHealthContribution: "Devlet sağlık katkısı",
	hrStateHealthContributionNote:
		"devlet tarafından sağlık paketinize eklenir (maaşınızdan kesilmez).",
	hrSuffixDays: "gün",
	hrSuffixHours: "sa",
	hrSuffixTimes: "×",
	hrSummary: "Özet",
	hrTabDefaultBenefits: "Varsayılan yan haklar",
	hrTabLeaveAccrual: "İzin birikimi",
	hrTabTaxCalculator: "Vergi hesaplayıcı",
	hrTabTaxesArmenia: "Vergiler (Ermenistan)",
	hrTabWorkSchedule: "Çalışma programı",
	hrTaxPreviewTitle: "Vergi önizlemesi (500.000 AMD brüt)",
	hrTaxRatesDescription: "Oranlar brüt maaşa uygulanır. Yüzde olarak girin (örn. 20 = %20).",
	hrTaxRatesDisclaimer:
		"2025–2026 Ermenistan mevzuatına göre oranlar. Gelir vergisi: standart %20, lisanslı BT için %10. Emeklilik: %5 (zorunlu/2018 öncesi gönüllü) veya düz %5 (2018 sonrası gönüllü). %10 ek emeklilik oranı, zorunlu/2018 öncü katılımcılar için 500.000 AMD üzeri gelirde geçerlidir. Bordro için muhasebeciye danışın.",
	hrThresholdWarning: "Eşik uyarısı",
	hrThresholdWarningText:
		"Maaşınız bir dilim sınırına yakın (100k / 200k / 500k / 1M AMD). Bu noktalarda damga ve sağlık sigortası üst dilime çıkar; küçük bir brüt artışı neti düşürebilir. Hesaplayıcı her zaman istenen net için minimum brütü gösterir.",
	hrTickets: "İK Biletleri",
	hrTotalDeductions: "Toplam kesintiler",
	hrTotalEmployeeDeductionsLabel: "Çalışan toplam kesintileri:",
	hrTransportAllowance: "Ulaşım yardımı",
	hrTransportAllowanceDesc: "Aylık ulaşım yardımı (AMD)",
	hrVacationDaysPerYear: "Yıllık izin günleri",
	hrVacationDaysPerYearDesc: "Yıllık tam hak (Ermenistan asgari: 20)",
	hrWorkingDayEnd: "Çalışma günü bitişi",
	hrWorkingDayEndDesc: "Beklenen vardiya bitişi. Günlük saatler başlangıç/bitişten hesaplanır",
	hrWorkingDayStart: "Çalışma günü başlangıcı",
	hrWorkingDayStartDesc: "Devam ve geç kalma kontrolü için beklenen giriş saati",
	hrWeekendDays: "Hafta sonu günleri",
	hrWeekendDaysDesc: "Haftanın hangi günlerinin çalışma dışı hafta sonu olduğunu seçin",
	hrWorkingDaysPerWeek: "Haftalık çalışma günleri",
	hrWorkingDaysPerWeekDesc: "Pzt–Cum = 5, Pzt–Cmt = 6",
	hrWorkingHoursPerDay: "Günlük çalışma saatleri",
	hrWorkingHoursPerDayDesc: "Fazla mesai başlamadan önceki normal saatler",
	href: "Href",
	humanResources: "İnsan Kaynakları",
	id: "ID",
	idCard: "Kimlik Kartı",
	idCardEndDate: "Kimlik Kartı Bitiş Tarihi",
	idCardNo: "Kimlik Kartı No",
	idCardStartDate: "Kimlik Kartı Başlangıç Tarihi",
	idCart: "Kimlik Kartı",
	image: "Görüntü",
	immediateSupervisor: "Acil Müdür",
	importance: "Önem",
	important: "Önemli",
	inProgress: "Devam Ediyor",
	inSelectedPeriod: "seçilen dönemde",
	inStock: "Stokta Var",
	in_progress: "Devam Ediyor",
	inactive: "Pasif",
	inactiveTime: "Pasif zaman",
	incident: "Olay",
	incomeTaxAmount: "Gelir vergisi tutarı",
	incomeTaxRate: "Gelir vergisi oranı (%)",
	incomingCall: "Gelen arama",
	incomingVideoCall: "Gelen video araması",
	incorrectLogin: "Yanlış kullanıcı adı veya şifre girdiniz",
	index: "#",
	inputInArmenian: "Ermenice giriş",
	inputInLatin: "Latince giriş",
	inputInNumbers: "Sayılarla giriş yapın",
	inputInRussian: "Rusça giriş",
	inputNumber: "Sayı girin",
	inputNumbers: "Sayıları girin",
	instagramPosts: "Instagram Gönderileri",
	insufficientVacationBalance: "Yetersiz tatil bakiyesi",
	interview1: "Mülakat",
	interview2: "Tanışma",
	interview3: "Eğitim",
	interview4: "Staj",
	interviewDate: "Görüşme tarihi",
	interviewTime: "Görüşme saati",
	introSection: "Giriş bölümü",
	invalidDate: "Geçersiz teslimat tarihi",
	inventorySummary: "Envanter Özeti",
	ip: "IP",
	ipAddress: "IP Adresi",
	isActive: "Aktif",
	isColor: "Renk",
	isPrivateOffice: "Özel ofis mi",
	isPublic: "Genel",
	itTickets: "IT Biletleri",
	items: "öğeler",
	justifiedAbsence: "Mazeretli devamsızlık",
	keyText: "Anahtar Metin",
	keyboards: "Klavye",
	label: "Etiket",
	language: "Dil",
	languagePickerLabel: "Dil",
	large: "Büyük",
	last7Days: "son 7 günde giriş yaptı",
	lastAction: "Son işlem",
	lastLogin: "Son giriş",
	lastName: "Soyad",
	lastOut: "Son çıkış",
	lastPunch: "Son giris/cikis",
	lasts: "Süre",
	latestCustomerOrders: "Son Müşteri Siparişleri",
	leader: "Lider",
	attendanceManagersFilter: "Yöneticiler",
	attendanceLeadersFilter: "Liderler",
	leaveBalance: "İzin bakiyesi",
	linkCopied: "Bağlantı kopyalandı",
	listeners: "Dinleyiciler",
	livingAddress: "Yaşadığı adres",
	loading: "Yükleniyor",
	loanDeductions: "Kredi kesintileri",
	localCode: "Yerel Kod",
	logOut: "Çıkış Yap",
	login: "Giriş",
	loginButton: "Giriş Yap",
	loginFailed: "Giriş başarısız",
	loginFailedMessage: "Lütfen giriş bilgilerinizi kontrol edin",
	loginSuccess: "Giriş başarılı",
	loginSuccessMessage: "Başarıyla giriş yaptınız",
	loginToStartSession: "Oturum açmak için giriş yapın",
	logout: "Çıkış",
	low: "Düşük",
	lunchCoverage: "Yemek yardımı",
	mac: "MAC",
	macAddress: "MAC Adresi",
	main: "Ana",
	itHierarchyAddLaptop: "Dizüstü bilgisayar ekle",
	itHierarchyAttachedPc: "Bağlı bilgisayar",
	itHierarchyLaptopsUsingPart: "Bu parçayı kullanan dizüstü bilgisayarlar",
	itUsedInOtherPlaces: "Diğer yerlerde kullanılıyor",
	mainInformation: "Temel bilgi",
	mainInfo: "Temel bilgiler",
	contactInfo: "İletişim bilgileri",
	personalInfo: "Kişisel bilgiler",
	workingInfo: "İş bilgileri",
	probation: "Deneme süresi",
	educationInfo: "Eğitim bilgileri",
	male: "Erkek",
	manualAdjustments: "Manuel düzeltmeler",
	manualAttendanceEntry: "Manuel giriş",
	maps: "Haritalar",
	maritalStatus: "Medeni hal",
	markAllAsRead: "Tümünü okundu işaretle",
	markSelectedAsRead: "Seçilenleri okundu işaretle",
	maternityLeave: "Doğum İzni",
	maxEnergy: "En fazla enerji",
	maxFilesReached: "Maksimum dosya sayısına ulaşıldı",
	maxSize: "Maksimum boyut",
	mediaGallery: "Medya Galerisi",
	mediaGalleryDescription: "Medya galerisi açıklaması",
	mediator: "Aracı",
	medium: "Orta",
	members: "Üyeler",
	menu: "Menü",
	message: "Mesaj",
	messages: "Mesajlar",
	messagesByType: "Türe Göre Mesajlar",
	messagesOverTime: "Zaman İçinde Mesajlar (Son 30 Gün)",
	militaryStampAmount: "Askeri damga tutarı",
	militaryStampRate: "Askeri damga oranı",
	minEnergy: "En az enerji",
	minute: "dakika",
	minutes: "Dakika",
	missingInterval: "Eksik aralık",
	mon: "Pazartesi",
	monitor: "Monitör",
	monitors: "Monitörler",
	month: "Ay",
	monthly: "Aylık",
	mood: "Hedef",
	more: "Ekstra",
	moreDetailed: "Daha ayrıntılı",
	moreThan: "Daha fazla",
	motherProject: "Ana Proje",
	mounted: "Monte edilmiş",
	mouses: "Fareler",
	moveToTrash: "Çöp kutusuna taşı",
	movedToTrash: "Çöp kutusuna taşındı",
	myActiveSteps: "Aktif adımlarım",
	myInvolvement: "Katılımım",
	myProjects: "Projelerim",
	myRole: "Benim rolüm",
	mySteps: "Adımlarım",
	myTickets: "Biletlerim",
	na: "Yok",
	name: "Ad",
	netCash: "Nakit net",
	netOfficial: "Resmi net",
	netSalary: "Net maaş",
	newClients: "Yeni Müşteriler",
	newClientsOverTime: "Zaman İçinde Yeni Müşteriler (Son 30 Gün)",
	newMessage: "Yeni mesaj",
	newProducts: "Yeni Ürünler",
	newProject: "Yeni Proje",
	newProjects: "Yeni Projeler",
	newThisPeriod: "Bu Dönemde Yeni",
	newTicket: "Yeni bilet",
	newTicketCreatedBy: "Yeni bilet oluşturuldu",
	newTracks: "Yeni Parçalar",
	newTracksOverTime: "Zaman İçinde Yeni Parçalar (Son 30 Gün)",
	next: "Sonraki",
	nextComposition: "Sonraki kompozisyon",
	nextStep: "Sonraki adım",
	noAccess: "Erişim yok",
	noActiveSteps: "Aktif adım yok",
	noBoardsFound: "Panolar bulunamadı",
	noCategoriesFound: "Kategoriler bulunamadı",
	noCategoryDataAvailable: "Kategori verisi yok",
	noContent: "İçerik yok",
	noCustomerDataAvailable: "Müşteri verisi yok",
	noData: "Veri mevcut değil",
	noDataAvailable: "Veri yok",
	noDataAvailableForSelectedPeriod: "Seçilen dönem için veri yok",
	noDepartment: "Bölüm yok",
	noDepartments: "Bölüm yok",
	noDescription: "Açıklama bulunamadı",
	noEmail: "E-posta Yok",
	noExpiringIdCards: "Süresi dolan kimlik kartı yok",
	noExpiringPassports: "Süresi dolan pasaport yok",
	noGroup: "Grup Yok",
	noMediaDescription: "Medya açıklaması bulunamadı",
	noMediaFound: "Medya bulunamadı",
	noMoreItems: "Daha fazla öğe yok",
	noName: "İsimsiz",
	noNeedStep45: "Adım 4-5 Gerekmiyor",
	noNotifications: "Bildirim yok",
	noOrdersInSelectedPeriod: "Seçilen dönemde sipariş yok",
	noOvertimeRecords: "Fazla mesai kaydı bulunamadı",
	noPaymentDataAvailable: "Ödeme verisi yok",
	noProjectsAssigned: "Atanmış proje yok",
	noProjectsAssignedOrInvolved: "Atanmış veya dahil projeler yok",
	noRecentContacts: "Son müşteri yok",
	noRecentContent: "Son içerik yok",
	noRecentTickets: "Son bilet yok",
	noRecentTracks: "Son parça yok",
	noRecipientInformation: "Alıcı bilgisi yok",
	noResponsible: "Sorumlu yok",
	noResult: "Sonuç bulunamadı",
	noResults: "Sonuç bulunamadı",
	noResultsFound: "Sonuç bulunamadı",
	noRulesAdded: "Planlama kuralları eklendi",
	noStatusData: "Durum verisi yok",
	noSystemDaysOffThisMonth: "Bu ay sistem genelinde izin günü yok",
	noTaskDataAvailable: "Görev verisi mevcut değil",
	noTasksYet: "Görevler yok",
	noTasksYetDescription: "Görevler yok",
	noUpcomingBirthdays: "Yaklaşan doğum günü yok",
	noUsersFound: "Kullanıcı bulunamadı",
	noUsersInDepartment: "Bu bölümde kullanıcı yok",
	noWorkHourData: "Çalışma saati verisi yok",
	no_priority: "Öncelik Yok",
	nonWorking: "Çalışılmayan gün",
	none: "Yok",
	notAvailable: "Ürün mevcut değil",
	notCorrectLoginCredentials: "Yanlış giriş bilgileri",
	notLoggedInToday: "Bugün giriş yapmadı",
	notPlaced: "Yerleştirilmedi",
	notPresent: "Yok",
	notResponded: "Yanıtlanmadı",
	notWorking: "Çalışmıyor",
	deviceProblems: "Cihaz sorunları",
	openTickets: "Açık talepler",
	note: "Not",
	nothingFound: "Hiçbir şey bulunamadı",
	notifications: "Bildirimler",
	notificationsBellAria: "Bildirimleri aç",
	similarTicketNotifications: "Benzer bilet bildirimleri",
	number: "Sayı",
	"office-map": "Ofis Haritası",
	officeMapActivatePlacement: "Yerleştirmeyi etkinleştir",
	officeMapAgent: "Ajan",
	officeMapAll: "Tümü",
	officeMapAttendanceDevice: "Devam Cihazı",
	officeMapAttendanceDevices: "Devam",
	officeMapCable: "Kablo",
	officeMapCableLinePlaced: "Kablo hattı yerleştirildi",
	officeMapCableRemovedFromMap: "Kablo haritadan kaldırıldı",
	officeMapCables: "Kablolar",
	officeMapCamera: "Kamera",
	officeMapCameras: "Kameralar",
	officeMapNvr: "NVR",
	officeMapChat: "Sohbet",
	officeMapChatWasNotCreated: "Sohbet oluşturulmadı",
	officeMapConnectToCamera: "Kameraya bağlan",
	officeMapCpu: "CPU",
	officeMapDeactivate: "Devre dışı bırak",
	officeMapDeviceDetails: "Cihaz Detayları",
	officeMapDeviceId: "Cihaz Kimliği",
	officeMapDisableDragging: "Sürüklemeyi devre dışı bırak",
	officeMapEnableDragging: "Sürüklemeyi etkinleştir",
	officeMapEndDeviceOptional: "Bitiş cihazı (isteğe bağlı)",
	officeMapFailedToMoveCable: "Kablo taşınamadı",
	officeMapFailedToMoveItem: "Öğe taşınamadı",
	officeMapFailedToMoveRoomArea: "Oda alanı taşınamadı",
	officeMapFailedToOpenChat: "Sohbet açılamadı",
	officeMapFailedToPlaceItem: "Öğe yerleştirilemedi",
	officeMapFailedToPlaceUser: "Kullanıcı yerleştirilemedi",
	officeMapFailedToRemoveCable: "Kablo kaldırılamadı",
	officeMapFailedToRemoveItem: "Öğe kaldırılamadı",
	officeMapFailedToRemoveRoomArea: "Oda alanı kaldırılamadı",
	officeMapFailedToSaveCableLine: "Kablo hattı kaydedilemedi",
	officeMapFailedToSaveRoomArea: "Oda alanı kaydedilemedi",
	officeMapFinishArea: "Alanı bitir",
	officeMapFinishCable: "Kabloyu bitir",
	officeMapForbidden: "Yasak",
	officeMapIp: "IP",
	officeMapItem: "Öğe",
	officeMapItemPlaced: "Öğe yerleştirildi",
	officeMapItemRemovedFromMap: "Öğe haritadan kaldırıldı",
	officeMapLaptop: "Dizüstü",
	officeMapLaptops: "Dizüstü bilgisayarlar",
	officeMapLayers: "Katmanlar",
	officeMapLinkedItRoom: "Bağlı IT odası",
	officeMapLive: "Canlı",
	officeMapMac: "MAC",
	officeMapMin: "min",
	officeMapMonitors: "Monitörler",
	officeMapNetworkCable: "Ağ Kablosu",
	officeMapNoDevicesInArea: "Bu alana yerleştirilmiş cihaz veya kullanıcı yok.",
	officeMapNoPermissionToPlaceItem: "Bu öğeyi yerleştirme izniniz yok.",
	officeMapNoPermissionToPlaceNetworkCable: "Ağ kablosu yerleştirme izniniz yok.",
	officeMapNoPermissionToPlaceRoomArea: "Oda alanı yerleştirme izniniz yok.",
	officeMapNoPermissionToRemoveItem: "Bu öğeyi haritadan kaldırma izniniz yok.",
	officeMapNoPermissionToRemoveNetworkCable: "Ağ kablosunu haritadan kaldırma izniniz yok.",
	officeMapNoPermissionToRemoveRoomArea: "Oda alanını haritadan kaldırma izniniz yok.",
	officeMapNotAvailable: "Yok",
	officeMapNotConnected: "Bağlı değil",
	officeMapPc: "PC",
	officeMapPcs: "PC'ler",
	officeMapPlacement: "Yerleştirme",
	officeMapPleaseSelectItemFirst: "Lütfen önce bir öğe seçin",
	officeMapPleaseSelectRoomFirst: "Lütfen önce bir oda seçin",
	officeMapPoints: "Noktalar",
	officeMapPorts: "Portlar",
	officeMapPrinted: "Yazdırıldı",
	officeMapPrinters: "Yazıcılar",
	officeMapRam: "RAM",
	officeMapRemoveFromMap: "Haritadan kaldır",
	officeMapRom: "ROM",
	officeMapRoomArea: "Oda Alanı",
	officeMapRoomAreaPlaced: "Oda alanı yerleştirildi",
	officeMapRoomAreaRemovedFromMap: "Oda alanı haritadan kaldırıldı",
	officeMapRoomAreas: "Odalar",
	officeMapRoomContents: "Oda içeriği",
	officeMapRouter: "Yönlendirici",
	officeMapRouters: "Yönlendiriciler",
	officeMapSelectItem: "Öğe seçin",
	officeMapSelectRoom: "Oda seçin",
	officeMapSpeed: "Hız",
	officeMapStartDeviceOptional: "Başlangıç cihazı (isteğe bağlı)",
	officeMapSwitches: "Switch'ler",
	officeMapTelephone: "Telefon",
	officeMapTelephones: "Telefonlar",
	officeMapUnknown: "Bilinmiyor",
	officeMapUrl: "URL",
	officeMapUserPlacedOnMap: "Kullanıcı haritaya yerleştirildi",
	officeMapUsers: "Kullanıcılar",
	officeMapViewContents: "İçeriği görüntüle",
	officeMapViewFullDetails: "Tüm detayları görüntüle",
	offline: "Çevrimdışı",
	offlinePaymentOnly: "Yalnızca çevrimdışı ödeme",
	oldProject: "Eski Proje",
	onSale: "Satışta",
	onSecond: "İkinci",
	onTime: "Zamanında",
	onTimeRate: "Zamaninda gelme orani",
	oneOf: "Bir",
	open: "Aç",
	openBoard: "Board aç",
	openDate: "Açılış Tarihi",
	openInModal: "Modal içinde aç",
	openInNewTab: "Yeni sekmede aç",
	openNavigation: "Gezintiyi aç",
	openedDate: "Açılış Tarihi",
	optional: "İsteğe bağlı",
	orClickToSelect: "veya dosya seçmek için tıklayın",
	order: "Sipariş",
	orderNumber: "Sipariş Numarası",
	orders: "Siparişler",
	ordersCart: "Sipariş Grafiği",
	otAfterWork: "İş sonrası fazla mesai",
	otBeforeWork: "İş öncesi fazla mesai",
	otherBenefits: "Diğer yan haklar",
	otherDeductions: "Diğer kesintiler",
	otherInsurance: "Diğer sigorta",
	outOfStock: "Stokta Yok",
	overdue: "Gecikmiş",
	overtimeComment: "Fazla mesai yorumu",
	overtimeDays: "Fazla mesai günleri",
	overtimeHours: "Fazla mesai saatleri",
	overtimeRate: "Fazla mesai oranı",
	overtimeSummary: "Fazla mesai özeti",
	overtimeTotal: "Toplam fazla mesai",
	overview: "Genel Bakış",
	owner: "Evin",
	ownership: "Sahiplik",
	pageNotFound: "Sayfa Bulunamadı",
	pageNotFoundDescription:
		"Hata! Aradığınız sayfa mevcut değil veya taşınmış. Kaldırılmış, adı değiştirilmiş veya geçici olarak kullanılamıyor olabilir.",
	pages: "Sayfalar",
	paid: "Ödenmiş",
	paidStatus: "Ödenmiş Durum",
	paidTimeOff: "Ücretli izin",
	paidTimeOffDays: "Ücretli izin günleri",
	parent: "Ebeveyn",
	parentCategory: "Ana kategori",
	parentDepartment: "Ana Departman",
	parentTask: "Ana Görev",
	parentType: "Üst Tür",
	parentUser: "Ana Kullanıcı",
	participant: "Katılımcı",
	passportEndDate: "Pasaport Bitiş Tarihi",
	passportImages: "Pasaport resimleri",
	passportNo: "Pasaport No",
	passportStartDate: "Pasaport Başlangıç Tarihi",
	password: "Şifre",
	pause: "Duraklat",
	paused: "Duraklatıldı",
	payDate: "Ödeme tarihi",
	paymentMethod: "Ödeme Yöntemi",
	paymentMethods: "Ödeme Yöntemleri",
	paymentSystem: "Ödeme Sistemi",
	payrollBreakdown: "Bordro dökümü",
	payrollCalcError: "Bordro hesaplaması başarısız oldu.",
	payrollCalcHint:
		"Çalışan ve dönem zorunludur. Bordro toplamlarını hesaplayıp kaydetmek için tıklayın.",
	payrollCalcMissingFields: "Lütfen çalışanı, dönem başlangıcını ve dönem bitişini seçin.",
	payrollCommentsForEmployee: "Çalışan için yorumlar",
	payrollGeneratedFromAttendance: "Devamsızlıktan oluşturulan bordro",
	payrollHealthInsurancePremium: "Sağlık sigortası (prim)",
	payrollIndexLabel: "Sıra no",
	payrollIndexPlaceholder: "İndeks",
	payrollInternalNotes: "Dahili notlar",
	payrollNotesSection: "Notlar",
	payrollType: "Bordro türü",
	payrollUsesHrSettings:
		"Fazla mesai, vergi oranları ve varsayılan yan haklar (yemek, ulaşım, sağlık) İK ayarlarından alınır (Sistem → İK ayarları).",
	pc: "Bilgisayar",
	pcHealth: "PC Sağlığı",
	pcs: "Bilgisayarlar",
	pdf: "PDF",
	penalties: "Cezalar",
	pending: "Bekliyor",
	pensionAmount: "Emeklilik kesintisi tutarı",
	pensionRate: "Emeklilik oranı",
	periodEnd: "Periyodun bitiş tarihi",
	periodStart: "Periyodun başlangıç tarihi",
	permInput_calendarEvent_overlayCustomCalendars: "Özel takvimler (filtre)",
	permInput_calendarEvent_overlayIt: "BT takvimleri (PC garanti)",
	permInput_calendarEvent_overlayPeople: "Kişi takvimleri (HR)",
	permInput_calendarEvent_overlayReminders: "Hatirlatici katmani",
	permInput_calendarEvent_overlayTasks: "Görevler (öncelik katmanları)",
	permInput_calendarEvent_overlayTickets: "Ticket katmani (alan bazli son tarihler)",
	permInput_chat_attachFile: "Dosya ekleme",
	permInput_chat_calling: "Sesli arama",
	permInput_chat_pin: "Mesaj sabitleme",
	permInput_chat_searchFiles: "Dosyalarda arama",
	permInput_chat_searchMessages: "Mesajlarda arama",
	permInput_chat_sendMessage: "Mesaj gonderme",
	permInput_chat_star: "Mesaj yildizlama",
	permInput_chat_videoCalling: "Goruntulu arama",
	permModuleCrud_download: "Takvim indirme (.ics içe aktar)",
	permModuleCrud_upload: "Takvim yükleme (.ics dışa aktar)",
	permanentDelete: "Kalıcı olarak silinsin mi?",
	permission: "İzin",
	permissions: "İzinler",
	persons: "Kişiler",
	phone: "Telefon",
	photo: "Fotoğraf",
	photos: "Fotoğraflar",
	pickEmoji: "Emoji seç",
	pinnedMessages: "Sabitlenmis mesajlar",
	placed: "Yerleştirildi",
	placedState: "Yerleştirilmiş durum",
	placeholder: "Yer Tutucu",
	platformDashboard: "Platform Dashboard",
	platformSpecificSettings: "Platforma özgü ayarlar",
	platforms: "Platformlar",
	audioPlaybackSpeed: "Oynatma hızı: {rate}. Değiştirmek için tıklayın.",
	playbackMute: "Sesi kapat",
	playbackUnmute: "Sesi aç",
	playbackVoiceMessage: "Sesli mesaj",
	playbackVideoMessage: "Görüntülü mesaj",
	previewVoiceMessage: "Sesli mesajı önizle",
	play: "Oynat",
	playStatus: "Oynatma durumu",
	playing: "Oynatma",
	playingComposition: "Çalınan kompozisyon",
	playingHistory: "Oynatma geçmişi",
	playlist: "Çalma Listesi",
	playlistStatistics: "Çalma Listesi İstatistikleri",
	playlistsWithAds: "reklamlı çalma listeleri",
	playlistsWithoutAds: "reklamsız çalma listeleri",
	podcast: "Podcast",
	podcastStreams: "podcast akışları",
	podcasts: "Podcast'ler",
	ports: "Portlar",
	position: "Pozisyon",
	positionReviewDate: "Pozisyon gözden geçirme tarihi",
	preDefinedFilters: "Ön tanımlı filtreler",
	preview: "Önizleme",
	previous: "Önceki",
	previousStep: "Önceki adım",
	price: "Fiyat",
	priceB2b: "Kurumsal Fiyat",
	priceBasic: "Temel Fiyat",
	priceGroup1: "Fiyat Grubu 1",
	priceGroup2: "Fiyat Grubu 2",
	priceGroup3: "Fiyat Grubu 3",
	priceLists: "Fiyat Listeleri",
	printedCount: "Baskı Sayısı",
	printer: "Yazıcı",
	printers: "Yazıcılar",
	priority: "Öncelik",
	priorityDescription: "Planlama kuralları",
	private: "Özel",
	privateChat: "Özel Sohbet",
	privateChatDescription: "Yalnızca seçilen kullanıcılar bu sohbeti görebilir ve katılabilir",
	problem: "Sorun",
	problemDescription: "Sorun Açıklaması",
	problemGroup: "Sorun Grubu",
	problemGroupSupervisorsPlaceholder:
		"Bu problem grubundaki biletlerin işlenmesinden sorumlu kullanıcılar",
	problemGroupSupervisorsTab: "Süpervizörler",
	processTime: "İşlem Süresi",
	processing: "İşleniyor",
	progress: "İlerleme",
	product: "Ürün",
	productCare: "Ürün Bakımı",
	products: "Ürünler",
	productsLinked: "Bağlı ürünler",
	project: "Proje",
	projectChanges: "Proje Değişiklikleri",
	projectDeadline: "Proje Teslim Tarihi",
	projectDetails: "Proje Detayları",
	projectEndDate: "Proje Bitiş Tarihi",
	projectID: "Proje Kimliği",
	projectPartition: "Proje Bölümü",
	projectPrice: "Proje fiyatı",
	projectPrice2: "Proje fiyatı",
	projectStartDate: "Proje Başlangıç Tarihi",
	projectType: "Proje Türü",
	projectTypes: "Proje Türleri",
	projects: "Projeler",
	promoCode: "Promosyon kodu",
	promoCodes: "Promosyon Kodları",
	promoCodesAndCertificates: "Promosyon Kodları ve Sertifikalar",
	promotions: "Promosyonlar",
	propertyNumber: "Mülk Numarası",
	providing: "Sağlama",
	punchActivity: "Giriş-çıkış hareketleri",
	pto: "Ücretli izin",
	partial: "Kısmi",
	quantity: "Miktar",
	radioDashboard: "Radyo Panosu",
	radioManagementOverview: "Radyo yayın yönetimi genel bakış",
	radioStatistics: "Radyo İstatistikleri",
	raises: "Zamlar",
	ram: "RAM",
	rate: "Oran",
	rating: "Rating",
	readOnly: "Yalnızca okunabilir",
	readOnlyChatNotice: "Bu sohbet uyeler icin salt okunurdur. Yalnizca yoneticiler mesaj yazabilir.",
	readyToGetStarted: "Başlamaya hazır",
	recalculatePayroll: "Bordroyu yeniden hesapla",
	recentClients: "Son Müşteriler",
	recentContent: "Son İçerik",
	recentMessages: "Son Mesajlar",
	recentOrders: "Son Siparişler",
	recentTickets: "Son Biletler",
	recentTracks: "Son Parçalar",
	refresh: "Yenile",
	registeredAddress: "Kayıtlı Adres",
	regularHours: "Normal saatler",
	regularHoursHrScheduleHint:
		"İK ayarlarından otomatik: dönemdeki iş günleri × günlük çalışma saati. Düzenlenebilir.",
	regularPlaylists: "Normal Çalma Listeleri",
	relatedList: "İlgili Liste",
	relatedObjects: "İlgili Nesneler",
	relatedProducts: "İlgili ürünler",
	relatedTasks: "İlgili Görevler",
	relations: "İlişkiler",
	remainingVacation: "Kalan tatil",
	remote: "Uzaktan",
	remoteWorkDays: "Uzaktan çalışma günleri",
	remove: "Kaldır",
	removeFromList: "Listeden Kaldır",
	removeItem: "Öğeyi Kaldır",
	removed: "Kaldırıldı",
	reopen: "Yeniden aç",
	replaceableProduct: "Değiştirilebilir ürün",
	replaceableProducts: "Değiştirilebilir ürünler",
	replied: "Yanıtlandı",
	reply: "Cevapla",
	request: "İstek",
	requestedForUser: "Talep Eden",
	reset: "Sıfırlamak",
	responseTimeDistribution: "Yanıt Süresi Dağılımı",
	responsible: "Sorumlu",
	responsibleAndUsers: "Sorumlu ve Kullanıcılar",
	restoreSelected: "Seçilenleri geri al",
	restored: "Geri alındı",
	returning: "Dönen",
	revenue: "Gelir",
	revenueOverview: "Gelir Özeti",
	review: "İnceleme",
	rightNow: "Hemen şimdi",
	role: "Rol",
	rom: "ROM",
	room: "Oda",
	routers: "Yönlendiriciler",
	rpaPrice: "RPA departmanı iş fiyatı",
	ruleName: "Kural adı",
	salary: "Maaş",
	salaryReviewDate: "Maaş gözden geçirme tarihi",
	sale: "Satış",
	salePrice: "Satış Fiyatı",
	salesBreakdownByCategory: "Kategoriye Göre Satış Dağılımı",
	salesPerformanceOverTime: "Zaman İçinde Satış Performansı",
	sat: "Cumartesi",
	save: "Kaydet",
	saveChanges: "Değişiklikleri kaydet",
	saveComment: "Yorumu kaydet",
	saved: "Kaydedildi",
	schedulingDisabled: "Planlama devre dışı",
	schedulingEnabled: "Planlama etkin",
	schedulingRules: "Planlama kuralları",
	search: "Ara",
	searchByNameOrId: "Ad veya ID ile arayın…",
	searchChat: "Sohbet ara...",
	searchChatGroups: "Grup sohbetlerinde ara...",
	searchConversations: "Ödeme tarihi",
	searchResults: "Arama Sonuçları",
	searchUsers: "Kullanıcı ara...",
	secondary: "İkincil",
	seconds: "saniye",
	securityAcknowledge: "Onayla",
	securityActions: "İşlemler",
	securityActiveBadge: "Aktif",
	securityActiveSessions: "Aktif oturumlar",
	securityActivityStatClicks: "Tıklamalar",
	securityActivityStatKeys: "Tuşlar",
	securityActivityStatMoves: "Hareketler",
	securityActivityTimeline: "Etkinlik zaman çizelgesi",
	securityAdminNotes: "Yönetici notları",
	securityAdminNotesDevice: "Bu cihaz hakkında dahili notlar...",
	securityAgentHeartbeat: "Aracı nabız",
	securityAlertClipPlural: "bu sayfadaki uyarı kayıtları",
	securityAlertClipSingular: "bu sayfadaki uyarı kaydı",
	securityAlertCount: "uyarı",
	securityAlertCountPlural: "uyarı",
	securityAlertDrawerNoMedia:
		"Bu uyarıya henüz medya bağlı değil. Ajan FFmpeg ile kaydedip yüklemeli. Windows’ta PATH veya FFMPEG_PATH. Ajan günlüğüne bakın.",
	securityAlertDrawerVideoFailed:
		"Video komutu gönderildi ancak yükleme yok. Ajan hatası olabilir — cihaz günlüğüne bakın.",
	securityAlertDrawerVideoPending:
		"Video kaydediliyor ve kısa sürede burada görünecek. Ajan cihazda çekim yapıp yüklüyor.",
	securityAlertRecordings: "Uyarı Kayıtları",
	securityAlertRecordingsOnly: "Yalnızca uyarı kayıtları",
	securityAlertSt_acknowledged: "onaylandı",
	securityAlertSt_false_positive: "yanlış alarm",
	securityAlertSt_open: "açık",
	securityAlertSt_resolved: "çözüldü",
	securityAlertsTitle: "Güvenlik uyarıları",
	securityAllDevices: "Tüm cihazlar",
	securityAllEventTypes: "Tüm türler",
	securityAllRules: "Tüm kurallar",
	securityAllSeverities: "Tüm önem dereceleri",
	securityAllStatuses: "Tüm durumlar",
	securityAppProcessTracking: "Uygulama / süreç izleme",
	securityAppTracking: "Uygulama izleme",
	securityAppUsageToday: "Bugün uygulama kullanımı (dk)",
	securityAssignedUser: "Atanan kullanıcı",
	securityBadgeAlertText: "UYARI",
	securityBadgeApp: "uyg",
	securityBadgeApps: "Uygulamalar",
	securityBadgeCapture: "yakala",
	securityBadgeFiles: "Dosyalar",
	securityBadgeOff: "kapalı",
	securityBadgeScr: "ekran",
	securityBadgeScreenshot: "Ekran",
	securityBadgeVideo: "Video",
	securityBadgeWeb: "Web",
	securityCapture: "Yakalama",
	securityCaptureEnabledMaster: "Yakalama açık (ana)",
	securityCaptureEverySeconds: "Yakalama aralığı (sn)",
	securityCaptureMasterSwitch: "Yakalama açık (ana anahtar)",
	securityCaptureModes: "Yakalama modları",
	securityCaptureOffAlertBody:
		"Yakalama cihaz düzeyinde açıkça kapalı; politikayı geçersiz kılar. Uyarılar oluşur ancak ekran görüntüsü veya video kaydedilmez.",
	securityCaptureOffAlertTitle: "Yakalama geçersiz kılma: KAPALI",
	securityCaptureRecorded: "Yakalama kaydedildi",
	securityCaptureWhenOnDesc: "Açıkken ekran ve video olabilir; kapatınca ikisi de kapanır",
	securityChartMinutes: "dakika",
	securityChartVisits: "ziyaret",
	securityClearFilters: "Filtreleri temizle",
	securityClickLeft: "S",
	securityClickMiddle: "O",
	securityClickPlain: "tıklama",
	securityClickRight: "Sa",
	securityClipWord: "Klip",
	securityConnectedDevices: "Bağlı cihazlar",
	securityCreated: "Oluşturuldu",
	securityDeleteDevice: "Cihazı Sil",
	securityDeleteDeviceConfirm: "Silmek istediğinizden emin misiniz",
	securityDeleteDeviceNote:
		"Bu yalnızca güvenlik cihazı kaydını siler. IT'deki PC profili etkilenmez.",
	securityDeleteDeviceTitle: "Güvenlik Cihazını Sil",
	securityDeleteMedia: "Sil",
	securityDeletePolicyConfirm: "Bu politika silinsin mi?",
	securityDevice: "Cihaz",
	securityDeviceFallback: "Cihaz",
	securityDeviceIdLabel: "Cihaz ID",
	securityDeviceNotFound: "Cihaz bulunamadı",
	securityDeviceSettings: "Cihaz ayarları",
	securityDeviceSettingsHint:
		"Bu cihaz için politikayı geçersiz kılar. Boş bırakılırsa politikadan devralınır.",
	securityDevicesBreadcrumb: "Cihazlar",
	securityDevicesTitle: "Güvenlik cihazları",
	securityDevicesWithAlerts: "Uyarılı cihazlar",
	securityDividerCapture: "Yakalama",
	securityDividerNotes: "Notlar",
	securityDividerTracking: "İzleme",
	securityDuration: "Süre",
	securityEg15: "örn. 15",
	securityEg30: "örn. 30",
	securityEg300: "örn. 300",
	securityEg5: "örn. 5",
	securityEg60: "örn. 60",
	securityEnabled: "Etkin",
	securityEnd: "Bitiş",
	securityEventFlushSeconds: "Olay temizleme (sn)",
	securityEventsCount: "olay",
	securityEventsCountPlural: "olay",
	securityEvtAppProcess: "Uygulama / süreç",
	securityEvtAppUsage: "Uygulama kullanımı",
	securityEvtFileEvent: "Dosya olayı",
	securityEvtHeartbeat: "Heartbeat",
	securityEvtInputActivity: "Giriş etkinliği",
	securityEvtKeystroke: "Tuş vuruşu",
	securityEvtMouseClick: "Fare tıklaması",
	securityEvtSessionEnd: "Oturum sonu",
	securityEvtSessionStart: "Oturum başlangıcı",
	securityEvtSystemBoot: "Sistem başlatma",
	securityEvtSystemShutdown: "Sistem kapatma",
	securityEvtUsb: "USB olayı",
	securityEvtUserLogin: "Kullanıcı girişi",
	securityEvtUserLogout: "Kullanıcı çıkışı",
	securityEvtWebVisit: "Web ziyareti",
	securityEvtWorkstationLock: "Ekran kilitlendi",
	securityEvtWorkstationUnlock: "Ekran kilidi açıldı",
	securityFailedLoadOverview: "Güvenlik özeti yüklenemedi",
	securityFailedSavePolicy: "Politika kaydedilemedi",
	securityFalsePositiveBtn: "Yanlış alarm",
	securityFileEventTracking: "Dosya olayları izleme",
	securityFilterByDate: "Tarihe göre filtre",
	securityFilterDateRange: "Tarih aralığına göre filtre",
	securityFilteredSuffix: "(filtreli)",
	securityFps: "FPS",
	securityHostname: "Ana bilgisayar",
	securityInputActivityCounts: "Giriş etkinliği (sayım)",
	securityInputKeystrokeClickTracking: "Tuş/tıklama izleme",
	securityInputModeActivityCountsShort: "Yalnızca etkinlik — tuş/tıklama sayısı",
	securityInputModeActivityOnly: "Yalnızca etkinlik (sayım)",
	securityInputModeDisabled: "Kapalı",
	securityInputModeDisabledShort: "Kapalı — giriş metriği yok",
	securityInputModeEventsOnly: "Yalnızca olaylar",
	securityInputModeEventsStream: "Yalnızca olaylar — ham akış",
	securityInputModeFullDetail: "Tam ayrıntı (tuş+tıklama)",
	securityInputModeFullKeystrokes: "Tam ayrıntı — tuşlar + tıklama konumları",
	securityInputModeShort: "Giriş modu",
	securityInputTrackingMode: "Giriş izleme modu",
	securityInternalNotesPlaceholder: "Dahili notlar...",
	securityKeyCharPrefix: "tuş:",
	securityLastSeen: "Son görülme",
	securityLatestClip: "Son klip",
	securityLinkedItPc: "Bağlı IT bilgisayarı:",
	securityLiveLoadingSub: "Ajana bağlanılıyor — ekran önizlemesi birazdan görünecek.",
	securityLiveOfflineHint: "Cihaz çevrimdışı — canlı görüntü için bağlı ajan gerekir.",
	securityLivePressStart: "Akışı açmak için Canlıyı başlat’a basın.",
	securityLiveScreenAlt: "Canlı ekran",
	securityLiveStatusLive: "CANLI",
	securityLiveStatusStandby: "Beklemede",
	securityLiveStreamHint:
		"Akış yarı çözünürlükte, saniyede 10 kareye kadar. Ajan v1.4.0+ ve jimp gerekli.",
	securityLiveWaitingFrames: "Canlı akış yükleniyor…",
	securityLoggedInSince: "Giriş tarihi",
	securityLoggedOutSince: "Son çıkış",
	securityMediaPrefix: "Medya",
	securityMediaTitle: "Güvenlik medyası",
	securityMiddleClick: "orta tık",
	securityModuleErrorTitle: "Güvenlik modülü hatası",
	securityName: "Ad",
	securityNearbyScreenshots: "Yakın ekran görüntüleri",
	securityNever: "Hiç",
	securityNewMediaBadge: "yeni",
	securityNewPolicy: "Yeni politika",
	securityNoActivityEvents: "Etkinlik olayı yok",
	securityNoAlertRecordingsPage: "Bu sayfada uyarı kaydı yok",
	securityNoAlertsForDevice: "Bu cihaz için uyarı yok",
	securityNoAlertsFound: "Uyarı bulunamadı",
	securityNoDevicesFound: "Cihaz bulunamadı",
	securityNoEventsMatchFilter: "Filtreyle eşleşen olay yok",
	securityNoOpenAlerts: "Açık uyarı yok",
	securityNoPoliciesConfigured: "Politika yok. İzlemeye başlamak için oluşturun.",
	securityNoPreview: "Önizleme yok",
	securityNoRiskyDevices: "Riskli cihaz yok",
	securityNoScreenshotsFound: "Ekran görüntüsü yok",
	securityNoScreenshotsYet: "Henüz ekran görüntüsü yok",
	securityNoSessionsFound: "Oturum bulunamadı",
	securityNoSessionsRecorded: "Kayıtlı oturum yok",
	securityNoUserSession: "Kullanıcı oturumu yok",
	securityNoUserSessionLiveHint:
		"PC açık ama kullanıcı oturum açmamış. Canlı görüntü ve ekran görüntüleri kullanılamaz.",
	securityNoUserSessionTitle: "Kullanıcı girişi yok",
	securityNoVideoSegmentsFound: "Video segmenti yok",
	securityNoVideosYet: "Henüz video segmenti yok",
	securityOS: "İS",
	securityOnlineDevices: "Çevrimiçi cihazlar",
	securityOpenAlerts: "Açık uyarılar",
	securityOpenPcRecord: "PC kaydını aç",
	securityOverrideOff: "KAPALI",
	securityOverrideOn: "AÇIK",
	securityOverridePrefix: "Geçersiz kılma:",
	securityOverviewTitle: "Güvenlik özeti",
	securityPageOf: "sayfa",
	securityPolActivityTrackingDivider: "Etkinlik izleme",
	securityPolAfterHoursStart: "Mesai dışı başlangıç",
	securityPolAlertClipLength: "Uyarı video klip süresi (sn)",
	securityPolAlertScore: "Uyarı skoru (0–100)",
	securityPolAlertSeverity: "Uyarı önem derecesi",
	securityPolAlertVideoDivider: "Uyarı videosu kaydı",
	securityPolAlertVideoInfo:
		"Kural tetiklenince ajan aşağıdaki ayarlarla tek masaüstü videosu kaydeder. Süre ve kalite tüm kurallar için aynıdır.",
	securityPolAllowedHoursDivider: "İzin verilen yakalama saatleri",
	securityPolBadgeAlert: "Uyarı",
	securityPolBlockedApps: "Engellenen uygulamalar",
	securityPolBlockedAppsPh: "örn. telegram, discord, torrent",
	securityPolBlockedDomains: "Engellenen alan adları",
	securityPolBlockedDomainsPh: "örn. torrent-site.com, telegram.org",
	securityPolBreadcrumbPolicies: "Politikalar",
	securityPolBulkThreshold: "Toplu dosya olayı eşiği (olay/toplu)",
	securityPolBulkThresholdDesc:
		"Bu kuralı tetiklemek için bir yükleme grubundaki yıkıcı dosya olayı sayısı",
	securityPolCollectInputMetrics: "Giriş etkinliği metriklerini topla",
	securityPolCollectInputMetricsDesc: "Yalnızca fare/klavye olay sayımları (tuş içeriği yok)",
	securityPolCreateAlert: "Uyarı oluştur",
	securityPolCreateAlertDesc:
		"Kural eşleşince güvenlik uyarısı açılır (video Yakalama sekmesi ayarlarını kullanır)",
	securityPolDescription: "Açıklama",
	securityPolEditPolicy: "Politikayı düzenle",
	securityPolEnableRule: "Kuralı etkinleştir",
	securityPolEventsRetention: "Olay saklama (gün)",
	securityPolEventsRetentionDesc: "Bu süreden eski etkinlik kayıtları silinir",
	securityPolExcludedDomains: "Hariç alan adları",
	securityPolExcludedDomainsPh: "örn. online-banking.com",
	securityPolExcludedProcesses: "Hariç işlem adları",
	securityPolExcludedProcessesPh: "örn. 1Password, Bitwarden",
	securityPolInputActivityCounts: "Yalnızca etkinlik — fare/tuş sayımları",
	securityPolInputDisabledNoTrack: "Kapalı — giriş izleme yok",
	securityPolInputEventsCount: "Yalnızca olaylar — yalnızca tuş sayımları",
	securityPolInputFullDetail: "Tam ayrıntı — tuşlar + tıklama konumları",
	securityPolInputModeLabel: "Giriş izleme modu",
	securityPolInputTrackingDivider: "Giriş izleme",
	securityPolMaskSensitive: "Hassas pencereleri maskele (şifre yöneticisi, banka)",
	securityPolMaskSensitiveDesc: "Hariç uygulama/pencereler için ekran görüntüsü alma",
	securityPolMaxFps: "Maks FPS",
	securityPolMediaRetention: "Medya saklama (gün)",
	securityPolMediaRetentionDesc: "Bu süreden eski ekran görüntüleri ve videolar silinir",
	securityPolNewSecurityPolicy: "Yeni güvenlik politikası",
	securityPolNotifyUsersDesc:
		"Seçilen kullanıcılar, bu politikadaki herhangi bir kural uyarı oluşturduğunda uygulama içi bildirim alır.",
	securityPolNotifyUsersLabel: "Politika tetiklendiğinde yöneticileri bildir",
	securityPolNotifyUsersPh: "Bildirim gönderilecek kullanıcıları arayın…",
	securityPolPolicyName: "Politika adı",
	securityPolPolicyNamePh: "örn. Geliştirici ekibi politikası",
	securityPolPriority: "Öncelik",
	securityPolPriorityDesc: "Yüksek sayı = önce değerlendirilir",
	securityPolRecordVideoOnAlert: "Güvenlik uyarısında video kaydet",
	securityPolRecordVideoOnAlertDesc: "Kapalıysa uyarı oluşur ama video kaydı olmaz",
	securityPolRuleAfterHoursDesc: "Tanımlı çalışma saatleri dışında etkinlik olunca tetiklenir.",
	securityPolRuleAfterHoursLabel: "Mesai dışı etkinlik",
	securityPolRuleBlockedAppDesc: "İzlenen kullanıcı engelli listeden uygulama açınca tetiklenir.",
	securityPolRuleBlockedAppLabel: "Engellenen uygulama",
	securityPolRuleBlockedDomainDesc: "İzlenen kullanıcı engelli alanı ziyaret edince tetiklenir.",
	securityPolRuleBlockedDomainLabel: "Engellenen alan",
	securityPolRuleBulkFileDesc:
		"Tek grupta çok sayıda dosya silme/yeniden adlandırma/taşıma olunca tetiklenir.",
	securityPolRuleBulkFileLabel: "Toplu dosya işlemleri",
	securityPolRuleUsbDesc: "İzlenen cihaza USB bağlanınca tetiklenir.",
	securityPolRuleUsbLabel: "USB depolama algılandı",
	securityPolRulesIntro:
		"Kurallar ihlali ve uyarı puanını tanımlar. «Uyarı oluştur» açıksa güvenlik uyarısı oluşur; video Yakalama sekmesindeki ayarlarla aynıdır.",
	securityPolSavePolicy: "Politikayı kaydet",
	securityPolScope: "Kapsam",
	securityPolScopeDepartment: "Departman",
	securityPolScopeDevice: "Belirli cihazlar",
	securityPolScopeGlobal: "Genel — tüm cihazlara uygulanır",
	securityPolScopeUser: "Belirli kullanıcılar",
	securityPolTabCapture: "Yakalama",
	securityPolTabPrivacy: "Gizlilik ve istisnalar",
	securityPolTabRetention: "Saklama",
	securityPolTabRules: "Kurallar",
	securityPolTrackApps: "Aktif uygulamaları izle",
	securityPolTrackFiles: "Dosya etkinliğini izle",
	securityPolTrackWebsites: "Web sitesi ziyaretlerini izle",
	securityPolTrackingMaster: "İzleme açık (ana anahtar)",
	securityPolTrackingMasterDesc: "Kapalıyken uygulama, web, dosya ve giriş izleme kapalı",
	securityPolVisibleNotice: "Çalışanlara görünür izleme bildirimi göster",
	securityPolVisibleNoticeDesc: "İzlemenin açık olduğunu bildiren bir şerit gösterir",
	securityPolWorkDayStart: "İş günü başlangıcı (mesai dışı sonu)",
	securityPolWorkingHours: "Çalışma saatleri (isteğe bağlı)",
	securityPolWorkingHoursDesc:
		"Yalnızca bu aralıkta yakala. Biçim: SS:DD-SS:DD örn. 09:00-18:00. Boş = her zaman.",
	securityPolWorkingHoursPh: "09:00-18:00",
	securityPoliciesCaptureHint:
		"Rozetler neyin açık olduğunu gösterir. Ekran görüntüsü, video, uygulama, web veya dosyaları açıp kapatmak için politikayı (kalem) açın → Yakalama sekmesi.",
	securityPoliciesTitle: "Güvenlik politikaları",
	securityPolicyDefaultBadge: "Politika varsayılanı",
	securityPriority: "Öncelik",
	securityQueued: "Kuyrukta!",
	securityRecentOpenAlerts: "Son açık uyarılar",
	securityRecentScreenshots: "Son ekran görüntüleri",
	securityRecordEverySeconds: "Kayıt aralığı (sn)",
	securityRecordVideo30s: "Video kaydet (30 sn)",
	securityRefresh: "Yenile",
	securityResolution: "Çözünürlük",
	securityResolutionNotePlaceholder: "Çözüm notu (isteğe bağlı)",
	securityResolve: "Çöz",
	securityRightClick: "sağ tık",
	securityRule: "Kural",
	securityRuleCode_AFTER_HOURS: "Mesai dışı",
	securityRuleCode_BLOCKED_APP: "Engelli uygulama",
	securityRuleCode_BLOCKED_DOMAIN: "Engelli alan",
	securityRuleCode_BULK_FILE_EVENTS: "Toplu dosya olayları",
	securityRuleCode_USB_DETECTED: "USB algılandı",
	securitySaveSettings: "Ayarları kaydet",
	securitySaved: "Kaydedildi",
	securityScope: "Kapsam",
	securityScopeType_department: "Departman",
	securityScopeType_device: "Cihaz",
	securityScopeType_global: "Genel",
	securityScopeType_user: "Kullanıcı",
	securityScreenshotAlt: "Ekran görüntüsü",
	securityScreenshotOptionsBlank: "Ekran seçenekleri (boş = politika varsayılanı)",
	securityScreenshots: "Ekran görüntüleri",
	securityScreenshotsCount: "Ekran görüntüleri",
	securityScreenshotsLabel: "Ekran görüntüleri",
	securityScreenshotsToday: "Bugünkü ekran görüntüleri",
	securitySearch: "Ara",
	securitySearchDevicesPlaceholder: "Ana bilgisayar, cihaz ID, kullanıcı ara...",
	securitySegmentLengthSeconds: "Segment süresi (sn)",
	securitySelectedCount: "seçili",
	securitySessionActive: "Aktif",
	securitySessionIdle: "Boşta",
	securitySessionLocked: "Ekran kilitli",
	securitySessionLockedCaptureHint:
		"Ekran kilitli — ekran görüntüsü ve canlı görüntü kullanılamaz.",
	securitySessionLockedLiveHint:
		"Kullanıcı ekranı kilitledi. Ekran kilitliyken canlı görüntü, ekran görüntüleri ve kayıtlar devre dışıdır.",
	securitySessionLockedSince: "Kilitlenme tarihi",
	securitySessionLockedTitle: "Ekran kilitli",
	securitySessionNotFound: "Oturum bulunamadı",
	securitySessionTimeline: "Oturum zaman çizelgesi",
	securitySessionWord: "Oturum",
	securitySessionsTitle: "Oturumlar",
	securitySettingsDrawerTitle: "Ayarlar",
	securitySettingsOverrideHint:
		"Yalnızca bu cihaz için politikayı geçersiz kılar. Olduğu gibi bırakın, politikadan devralınsın.",
	securitySev_critical: "kritik",
	securitySev_high: "yüksek",
	securitySev_low: "düşük",
	securitySev_medium: "orta",
	securitySeverity: "Önem",
	securityShowAllVideos: "Tüm videoları göster",
	securitySourceEvents: "Kaynak olaylar",
	securitySpeedSec: "Hız (sn):",
	securityStart: "Başlangıç",
	securityStartLive: "Canlıyı başlat",
	securityStatOf: "/",
	securityStatus: "Durum",
	securityStatus_error: "Hata",
	securityStatus_offline: "Çevrimdışı",
	securityStatus_online: "Çevrimiçi",
	securityStatus_pending: "Beklemede",
	securityStatus_unknown: "bilinmiyor",
	securityStopLive: "Canlıyı durdur",
	securityTabActivity: "Etkinlik",
	securityTabAlerts: "Uyarılar",
	securityTabLive: "Canlı",
	securityTabScreenshots: "Ekranlar",
	securityTabSessions: "Oturumlar",
	securityTabSettings: "Ayarlar",
	securityTabVideos: "Videolar",
	securityTakeScreenshot: "Ekran görüntüsü al",
	securityTitle: "Başlık",
	securityTooltipAppTrack: "Uygulama izlemeyi aç/kapat",
	securityTooltipCaptureMaster: "Ekran ve medya yakalamayı aç/kapat (ana)",
	securityTooltipScreenshot: "Ekran görüntüsü yakalamayı aç/kapat",
	securityTooltipTrackingMaster: "Uygulama, web, dosya ve giriş izlemenin ana anahtarı",
	securityTooltipWebTrack: "Web alanı izlemeyi aç/kapat",
	securityTopRiskyDevices: "En riskli cihazlar",
	securityTracking: "İzleme",
	securityTrackingEnabledMaster: "İzleme açık (ana)",
	securityTrackingMasterSwitch: "İzleme açık (ana)",
	securityTrackingOffAlertBody:
		"Etkinlik izleme cihaz düzeyinde açıkça kapalı; politikayı geçersiz kılar.",
	securityTrackingOffAlertTitle: "İzleme geçersiz kılma: KAPALI",
	securityTrackingWhenOffDesc: "Kapalıyken uygulama, web, dosya ve giriş izleme kapalı",
	securityUnassigned: "Atanmamış",
	securityUnknown: "Bilinmiyor",
	securityUnknownDevice: "Bilinmeyen cihaz",
	securityUsePolicyDefault: "Politika varsayılanı",
	securityUser: "Kullanıcı",
	securityUserLoggedIn: "Oturum açık",
	securityVideoOffAlertBody:
		"Video kaydı cihazda açıkça kapalı. Politika izin verse bile uyarı kayıtları alınmaz.",
	securityVideoOffAlertTitle: "Video geçersiz kılma: KAPALI",
	securityVideoOptionsBlank: "Video seçenekleri (boş = politika)",
	securityVideoPlayAllHint:
		"Seçili klipten eski segmentlere kadar oynat; sayfa bitince sonraki yüklenir.",
	securityVideoRecording: "Video kaydı",
	securityVideoSegments: "Video segmentleri",
	securityVideoSegmentsCount: "Video segmentleri",
	securityViewDetail: "Detay",
	securityWebDomainTracking: "Web alanı izleme",
	securityWebPollSeconds: "Web geçmişi yoklama (sn)",
	securityWebTracking: "Web izleme",
	securityWebsiteVisitsToday: "Bugün site ziyaretleri",
	securityWhen: "Ne zaman",
	selectAlbum: "Albüm Seç",
	selectAll: "Tümünü seç",
	selectArtist: "Sanatçı seç",
	selectBoard: "Board seç",
	selectCategory: "Kategori seç",
	selectChatPartner: "Sohbet ortağını seç",
	selectClosedDate: "Kapanış tarihini seçin",
	selectDate: "Tarih seç",
	selectDays: "Günleri seç",
	selectDomain: "Alan seçin",
	selectEmployee: "Çalışan seçin",
	selectFiles: "Dosyaları seç",
	selectGroup: "Grup seçin",
	selectOpenedDate: "Açılış tarihini seçin",
	selectParentDepartment: "Ana Departman Seçin",
	selectParentUser: "Ana Kullanıcı Seçin",
	selectPeriod: "Dönem seçin",
	selectPlatformToManageAndNavigate: "Platform Dashboard",
	selectPlaylist: "Oynatma listesini seç",
	selectProduct: "Ürün seçin",
	selectSomething: "Bir şey seçin",
	selectUsers: "Kullanıcıları Seçin",
	selectedSteps: "Seçilen Adımlar",
	selectedUsers: "Seçilen Kullanıcılar",
	seleteSelected: "Seçilenleri seç",
	send: "Gönder",
	sent: "Gönderildi",
	seoDesc: "SEO Açıklama",
	servicesAndPrices: "Hizmetler ve Fiyatlar",
	setCostOfBuildingPermit: "İnşaat izni maliyetini ayarla",
	setDayOff: "İzin günü ayarla",
	settings: "Ayarlar",
	shiftSchedule: "Vardiya Programı",
	showAllSteps: "Tüm adımları göster",
	showHistory: "Geçmişi göster",
	showProjectDetails: "Proje ayrıntılarını göster",
	showTableColumnFilters: "Sütun filtrelerini göster",
	showTimeline: "Zaman çizelgesini göster",
	showing: "Gösteriliyor",
	shuffle: "Karıştır",
	shuffleEnabled: "Karıştırma Etkin",
	shuffleOverride: "Planlama kuralları",
	shuffleOverrideDesc: "Planlama kuralları",
	shuffleOverrideValue: "Planlama kuralları",
	sickLeave: "Hastalık izni",
	sickLeaveDays: "Hastalık izni günleri",
	signIn: "Giriş Yap",
	signUp: "Kayıt Ol",
	size: "Boyut",
	slider: "Kaydırıcı",
	small: "Küçük",
	smb: "Sunucu klasörü",
	socialAmount: "Sosyal ödeme tutarı",
	socialCardImages: "Sosyal kart resimleri",
	socialCart: "Sosyal Kart",
	socialNetworkLink: "Sosyal Ağ Bağlantısı",
	socialRate: "Sosyal ödeme oranı",
	software: "Yazılım",
	softwareSkills: "Yazılım Becerileri",
	somethingWentWrong: "Bir şeyler ters gitti",
	somethingWentWrongInCreatingSteps:
		"Adımlar oluşturulurken bir şeyler ters gitti! Lütfen tekrar deneyin",
	sortBy: "Sırala",
	source: "Kaynak",
	special: "Özel",
	specialItems: "Özel Ürünler",
	speed: "Hız",
	starred: "Yıldızlı",
	starredMessages: "Yildizli mesajlar",
	start: "Başlat",
	startCall: "Aramayı başlat",
	startDate: "Başlangıç Tarihi",
	startDateShort: "Başlangıç Tarihi",
	startRecording: "Kayda başla",
	startTime: "Başlangıç saati",
	startVideoCall: "Video aramayı başlat",
	starts: "Başlıyor",
	state: "Eyalet",
	states: "Eyaletler",
	status: "Durum",
	visibility: "Görünürlük",
	statusUpdate: "Durum Güncelleme",
	stayAnonymous: "Anonim kal",
	step: "Adım",
	stepIsNotStartedYet: "Adım henüz başlamadı",
	stepStatus: "Adım Durumu",
	stepStatusChangedByUser: "Kullanıcı tarafından adım durumu değiştirildi",
	steps: "Adımlar",
	stepsLeft: "Kalan Adımlar",
	stillInOffice: "Hâlâ ofiste",
	stockAndProductOverview: "Stok ve Ürün Genel Bakış",
	stop: "Durdur",
	stopRecording: "Kaydı durdur",
	stopped: "Durduruldu",
	streamDJ: "Akış DJ",
	streamStatistics: "Akış İstatistikleri",
	streaming: "Akış",
	streamsWithShuffle: "karıştırmalı akışlar",
	street: "Sokak",
	subDesc: "Alt Açıklama",
	submit: "Gönder",
	submittedProjects: "Gönderilen Projeler",
	subscription: "Abonelik",
	subscriptions: "Abonelikler",
	substation: "Trafo Merkezi",
	substationNumber: "Trafo Merkezi Numarası",
	subtasks: "Alt Görevler",
	subtasksPlaceholder: "Her alt görevi yeni bir satırda girin",
	subtitle: "Alt başlık",
	success: "Başarı",
	suffix: "Sonek",
	sun: "Pazar",
	support: "Destek",
	supportText: "Tüm sorular için yazın",
	switch: "Anahtar",
	switchers: "Anahtarlayıcılar",
	switches: "Yazıcılar",
	syncedFromGoogleContacts: "Google Kişiler'den senkronize edildi",
	systemSettings: "Sistem ayarları",
	table: "Tablo",
	tag: "Etiket",
	tags: "Tags",
	takeMeHome: "Ana Sayfaya Dön",
	taskCreatedSuccessfully: "Görev başarıyla oluşturuldu",
	taskCreatedSuccessfullyDescription: "Görev başarıyla oluşturuldu",
	taskDescription: "Görev Açıklaması",
	taskMoved: "Görev taşındı",
	taskMovedDescription: "Görev yeni bir kategoriye taşındı",
	taskStatusDistribution: "Görev Durumu Dağılımı",
	taskTitle: "Görev Başlığı",
	tasksAssigned: "Atanan Görevler",
	taxCode: "Vergi Kodu",
	taxNote: "Etiket",
	taxes: "Vergiler",
	technicalFilesUrl: "Teknik Dosyalar URL",
	telegram: "Telegram",
	text: "Metin",
	theConstructionDepPrice: "İnşaat bölümü fiyatı",
	theNumberOfAct: "Eylem sayısı",
	thePriceOfProject: "Proje fiyatı",
	themePickerLabel: "Tema",
	thereIsNoResponsible: "Sorumlu yok",
	thisMonth: "bu ay",
	thu: "Perşembe",
	ticket: "Bilet",
	ticketClosed: "Bilet kapandı",
	ticketCreateSaveDisabledHint:
		"Kaydetmeden önce alan, sorun grubu (varsa), sorun seçin ve gerekli ilişkili alanları doldurun.",
	ticketDashboard: "Bilet Panosu",
	ticketDomain: "Alan",
	ticketHierarchyAddProblem: "Sorun ekle",
	ticketHierarchyAddProblemGroup: "Sorun grubu ekle",
	ticketHierarchyAddRelatedList: "İlişkili liste ekle",
	ticketHierarchyAddTicket: "Bilet ekle",
	ticketHierarchyAddTicketDomain: "Alan ekle",
	ticketHierarchyAddTicketHint: "Bu alan seçili yeni bilet oluşturma açılır.",
	ticketHierarchyGroupsInDomain: "Bu alandaki sorun grupları",
	ticketHierarchyNoneYet: "Henüz yok — yukarıdaki düğmeyi kullanın.",
	ticketHierarchyProblemsInGroup: "Bu gruptaki sorunlar",
	ticketHierarchyProblemsLinkedToList: "Bu listeyi kullanan sorunlar",
	ticketSystemOverview: "Bilet sistemi performansı ve metriklerine genel bakış",
	ticketTitle: "Başlık",
	ticketType: "Tür",
	ticketTypeDomainsHint:
		"Tüm alanlarda kullanılabilir olsun diye boş bırakın. Yalnızca seçtiğiniz alanlarda görünsün diye bir veya daha fazla alan seçin.",
	ticketTypeDomainsListAll: "Tüm alanlar",
	ticketStatus_sent: "Gönderildi",
	ticketStatus_in_process: "İşlemde",
	ticketStatus_resolved_rejected: "Reddedildi",
	ticketStatus_resolved_approved: "Onaylandı",
	ticketStatus_moved_next: "Sonraki adıma taşındı",
	ticketStatus_moved_prev: "Önceki adıma geri alındı",
	ticketStatus_closed: "Kapatıldı",
	ticketStatus_not_accepted: "Kabul edilmedi",
	ticketAction_start: "İşleme başla",
	ticketAction_next: "Sonraki adım",
	ticketAction_prev: "Önceki adım",
	ticketAction_approve: "Onayla",
	ticketAction_reject: "Reddet",
	ticketAction_close: "Bileti kapat",
	ticketAction_cancel: "Bileti iptal et",
	ticketAction_comment: "Yorum",
	cancelTicket: "Bileti iptal et",
	ticketCancelReason: "İptal nedeni",
	ticketCancelComment: "Ek yorum",
	ticketCancelCommentPlaceholder: "Gerekirse açan kullanıcı için ayrıntı ekleyin",
	ticketCancelWarning:
		"Bu bilet kabul edilmedi olarak işaretlenip kapatılacak. Kullanıcının hâlâ yardıma ihtiyacı varsa yeni bir bilet açması gerekir.",
	ticketNotAccepted: "Bilet kabul edilmedi",
	ticketStepStatus_pending: "Beklemede",
	ticketStepStatus_active: "Aktif",
	ticketStepStatus_completed: "Tamamlandı",
	ticketStepStatus_approved: "Onaylandı",
	ticketStepStatus_rejected: "Reddedildi",
	ticketStepStatus_closed: "Kapatıldı",
	ticketStepStatus_cancelled: "İptal edildi",
	tickets: "Biletler",
	ticketsByDepartment: "Departmana Göre Biletler",
	ticketsByImportance: "Önceliğe Göre Biletler",
	ticketsByProblem: "Sorun Türüne Göre Biletler",
	ticketsByStatus: "Duruma Göre Biletler",
	ticketsOverTime: "Zaman İçinde Biletler",
	timAgreement: "TIM anlaşması",
	timDelays: "TIM gecikmeleri",
	timSentProjects: "TIM'e Gönderilen Projeler",
	time: "Zaman",
	timeBasedScheduling: "Zaman tabanlı planlama",
	timeOff: "İzin",
	timeRange: "Zaman Aralığı",
	timeToClose: "bileti kapatma süresi",
	timeToFirstResponse: "ilk yanıt süresi",
	timeline: "Zaman Çizelgesi",
	timestamp: "Zaman Damgası",
	timezone: "Saat dilimi",
	title: "Başlık",
	to: "e",
	toChat: "Sohbete git",
	toDo: "Yapılacak",
	today: "Bugün",
	todaysSales: "Bugünün Satışları",
	todo: "Görevler",
	todoBoard: "Panel",
	todoBoards: "Panolar",
	todoCategories: "Kategoriler",
	todoCategory: "Kategori",
	todoLabel: "Etiket",
	todoLabels: "Etiketler",
	todoTag: "Etiket",
	todoTags: "Etiketler",
	todoTask: "Görev",
	todoTasks: "Görevler",
	toggles: "Anahtarlar",
	top: "En İyi",
	topCustomers: "En İyi Müşteriler",
	topProducts: "En İyi Ürünler",
	total: "Toplam",
	totalActiveTasks: "Toplam aktif görevler",
	totalArtists: "Toplam Sanatçı",
	totalChats: "Toplam Sohbetler",
	totalClients: "Toplam Müşteri",
	totalCoins: "Toplam Jeton",
	totalContent: "Toplam İçerik",
	totalCustomers: "Toplam Müşteri",
	totalDeductions: "Toplam kesintiler",
	totalDuration: "Toplam Süre",
	totalGroups: "toplam gruplar",
	totalHours: "Toplam saat",
	missingDays: "Eksik Günler",
	missingHours: "Eksik Saatler",
	scheduled: "Planlanan",
	totalHoursWorked: "Toplam çalışma süresi",
	totalInTrash: "Çöp kutusunda toplam",
	totalMessages: "Toplam Mesajlar",
	totalOrders: "Toplam Sipariş",
	totalOvertime: "Toplam Fazla Mesai",
	totalPlaylists: "Toplam Çalma Listesi",
	totalPrice: "Toplam fiyat",
	totalProducts: "Toplam Ürün",
	totalRevenue: "Toplam Gelir",
	totalTickets: "Toplam Bilet",
	totalTracks: "Toplam Parça",
	totalUses: "Toplam Kullanım",
	totalValue: "Toplam Değer",
	track: "Parça",
	trackPlaylist: "Parça çalma listesi",
	tracks: "Parçalar",
	tracksByArtist: "Sanatçıya Göre Parçalar",
	transportAllowance: "Ulaşım yardımı",
	trash: "Çöp kutusu",
	trashAutoDeleteWarning: "Çöp kutusunun otomatik silinmesi uyarısı",
	trashEmptied: "Çöp kutusunu temizlendi",
	trashedOn: "Çöpe taşınma",
	tryAgain: "Tekrar deneyin",
	tue: "Salı",
	type: "Tip",
	uncoveredInterval: "Kapsanmayan aralık",
	undefined: "Tanımsız",
	undo: "Geri al",
	university: "Üniversite",
	universityDegree: "Üniversite Derecesi",
	universityDepartment: "Üniversite Bölümü",
	unjustifiedAbsence: "Mazeretsiz devamsızlık",
	unknown: "Bilinmiyor",
	unknownArtist: "Bilinmeyen Sanatçı",
	unnamed: "İsimsiz",
	unnamedClient: "İsimsiz Müşteri",
	unnamedTrack: "İsimsiz Parça",
	unpaid: "Ücretsiz",
	unreadMessages: "Okunmamış Mesajlar",
	unresolvedMissingIntervals: "Çözümsüz eksik aralıklar — bordro hatalı olabilir",
	upcomingBirthdays: "Gelecek Doğum Günleri",
	update: "Güncelle",
	updatedAt: "Güncellenme Zamanı",
	updates: "Güncellemeler",
	upload: "Yükle",
	uploadDate: "Yükleme Tarihi",
	uploading: "Yükleniyor",
	uploads: "Yüklemeler",
	uptime: "Çalışma süresi",
	urgent: "Acil",
	used: "Kullanıldı",
	usedCount: "Kullanılan sayısı",
	usedVacation: "Kullanılan tatil",
	user: "Kullanıcı",
	userArchive: "Kullanıcı Arşivi",
	userDashboard: "Kullanıcı Panosu",
	userDeleted: "Silindi",
	userEntered: "Kullanıcı girdi",
	userProfile: "Kullanıcı Profili",
	userPayrollCalcUsesAttendance:
		"Bu hesaplama, {monthKey} için kanonik devam ve izin özetini kullanır, ardından İK Ayarlarındaki aktif vergi kurallarını uygular.",
	userUpdated: "Güncellendi",
	userVisited: "Kullanıcı ziyaret etti",
	username: "Kullanıcı Adı",
	users: "İnsan Kaynakları",
	vacationBalance: "Tatil bakiyesi",
	vacationDaysForPeriod: "Seçili dönem için tatil günleri",
	vacationInterval: "Tatil aralığı",
	vacationPay: "İzin ücreti",
	value: "Değer",
	version: "Sürüm",
	viber: "Viber",
	video: "Video",
	view: "Görünüm",
	viewAll: "Tümünü görüntüle",
	viewDetails: "Detayları Görüntüle",
	viewMore: "Daha Fazla Gör",
	viewProject: "Proje görüntüle",
	viewSteps: "Adımları görüntüle",
	viewTrash: "Çöp kutusunu görüntüle",
	village: "Köy",
	villages: "Köy listesi",
	visitation: "Ziyaret",
	visitationDeadline: "Ziyaret Son Tarihi",
	visitationDelays: "Ziyaret gecikmeleri",
	voltage: "Gerilim",
	voltageLevel: "Gerilim Seviyesi",
	volumes: "Hacimler",
	voluntaryPensionAmount: "Gönüllü emeklilik tutarı",
	voluntaryPensionRate: "Gönüllü emeklilik oranı (%)",
	vsPreviousPeriod: "Önceki Döneme Göre",
	warning: "Uyarı",
	warrantyDesc: "Garanti açıklaması",
	warrantyEnd: "Garanti bitiş",
	warrantyProvider: "Garanti sağlayıcı",
	warrantyStart: "Garanti başlangıç",
	watchers: "İzleyiciler",
	weatherAriaYerevanForecast: "Erivan hava durumu tahmini",
	weatherCityYerevan: "Erivan",
	weatherClear: "Açık",
	weatherCloudy: "Bulutlu",
	weatherDrizzle: "Çiseleyen yağmur",
	weatherFog: "Sis",
	weatherForecastUnavailable: "Tahmin kullanılamıyor",
	weatherHeadingYerevan: "Erivan hava durumu",
	weatherHumidity: "Nem",
	weatherLoadingShort: "Hava",
	weatherNextHours: "Önümüzdeki saatler",
	weatherPartlyCloudy: "Parçalı bulutlu",
	weatherRain: "Yağmur",
	weatherSnow: "Kar",
	weatherThunderstorm: "Gök gürültülü fırtına",
	weatherUnknown: "Tahmin",
	weatherWind: "Rüzgar",
	weatherWindUnit: "km/sa",
	wed: "Çarşamba",
	weekly: "Haftalık",
	whatToDo: "Ne yapmalı",
	whatToDoLink: "Ne yapmalı",
	whatsapp: "WhatsApp",
	withAttachments: "Ekleri Olan",
	withCoins: "Jetonlu",
	withFavorites: "Favorilerle",
	workDays: "Çalışma günleri",
	workInformation: "İş bilgileri",
	workTime: "Çalışma Saati",
	workedDays: "Çalışılan günler",
	workedHours: "Çalışılan saatler",
	working: "Çalışıyor",
	workingDays: "Çalışma Günleri",
	workingHoursByDay: "Güne Göre Çalışma Saatleri",
	workingMinutes: "Çalışma Dakikaları",
	workingState: "Çalışma durumu",
	workingStatus: "Çalışma Durumu",
	write: "Yaz",
	writeUsIfThereAreAnyQuestions: "Sorularınız varsa bize yazın",
	writingContent: "Yazı İçeriği",
	writingNumber: "Yazı Numarası",
	yes: "Evet",
	yesNextStep: "Evet, bir sonraki adıma geç",
	yesPreviousStep: "Evet, bir önceki adıma git",
	youWontBeAbleToRevert: "Bunu geri alamazsınız!",
	yourFileHasBeenDeleted: "Dosyanız silindi.",
	yourFileHasBeenNotSaved: "Dosyanız kaydedilmedi.",
	yourFileHasBeenSaved: "Dosyanız kaydedildi.",
	zipCode: "Posta Kodu",
	zipCodes: "Posta Kodları",
	vacationIntervalNoDeduction: "Tatil çalışma dışı günlerde düşülmez",
	knowledgeDashboardLoadFailed: "Kontrol paneli yüklenemedi",
	knowledgeArticlesLoadFailed: "Makaleler yüklenemedi",
	knowledgeBase: "Bilgi Bankası",
	knowledgeCreate: "Oluştur",
	knowledgeRunAutoDocs: "Otomatik Belgeleri Çalıştır",
	knowledgeTotalArticles: "Toplam makale",
	knowledgePublished: "Yayınlandı",
	knowledgeDrafts: "Taslaklar",
	knowledgeAutoGenerated: "Otomatik oluşturuldu",
	knowledgeLatestUpdatedArticles: "Son Güncellenen Makaleler",
	knowledgeArticles: "Makaleler",
	knowledgeNewArticle: "Yeni Makale",
	knowledgeFilterArticles: "Makaleleri filtrele",
	knowledgeCategories: "Kategoriler",
	knowledgeParentCategory: "Üst kategori",
	knowledgeIcon: "Simge",
	knowledgeColor: "Renk",
	knowledgeSortOrder: "Sıralama",
	knowledgeCategorySaved: "Kategori kaydedildi",
	knowledgeCategoryDeleted: "Kategori silindi",
	knowledgeSearch: "Arama",
	knowledgeSearchArticles: "Makalelerde ara",
	knowledgePath: "Yol",
	knowledgeAutoGeneratedDocs: "Otomatik Oluşturulan Belgeler",
	knowledgeSingleRoute: "Tek rota",
	knowledgeNoScreenshots: "Ekran görüntüsü yok",
	knowledgeGenerateDocumentation: "Dokümantasyon Oluştur",
	knowledgeImportGeneratedDocs: "Oluşturulan Belgeleri İçe Aktar",
	knowledgeDocumentationGenerationStarted: "Dokümantasyon oluşturma başladı",
	knowledgeImported: "İçe aktarıldı",
	knowledgeGeneratedDocsImported: "{count} oluşturulan belge içe aktarıldı",
	knowledgeStarted: "Başladı",
	knowledgeFinished: "Bitti",
	knowledgeRun: "Çalıştırma",
	knowledgeOutput: "Çıktı",
	knowledgeStatus_draft: "Taslak",
	knowledgeStatus_published: "Yayınlandı",
	knowledgeStatus_archived: "Arşivlendi",
	knowledgeVisibility_public: "Herkese açık",
	knowledgeVisibility_private: "Özel",
	knowledgeVisibility_company: "Şirket",
	knowledgeRunStatus_idle: "beklemede",
	knowledgeRunStatus_running: "çalışıyor",
	knowledgeRunStatus_completed: "tamamlandı",
	knowledgeRunStatus_failed: "başarısız",
	meetings: "Toplantılar",
	meetingsListSubtitle: "APIT sohbeti ve takvimi bağlı planlanmış odalar.",
	meetingsCreateMeeting: "Toplantı oluştur",
	meetingsEditMeeting: "Toplantıyı düzenle",
	meetingsCreateSubtitle: "Toplantı = takvim etkinliği + sohbet grubu + video odası.",
	meetingsMeetingType: "Toplantı türü",
	meetingsDate: "Tarih",
	meetingsStartTime: "Başlangıç saati",
	meetingsEndTime: "Bitiş saati",
	meetingsTimezone: "Saat dilimi",
	meetingsVisibility: "Görünürlük",
	meetingsParticipants: "Katılımcılar",
	meetingsGroupsDepartments: "Gruplar/departmanlar",
	meetingsOptionalGroupIds: "İsteğe bağlı grup kimlikleri",
	meetingsLocation: "Konum",
	meetingsReminderTime: "Hatırlatma zamanı",
	meetingsMinutesShort: "dk",
	meetingsAgenda: "Gündem",
	meetingsAgendaPlaceholder: "Başlangıç\nTasarım incelemesi\nSonraki adımlar",
	meetingsRecordingEnabled: "Kayıt etkin",
	meetingsAllowJoinBeforeHost: "Sunucudan önce katılmaya izin ver",
	meetingsMuteUsersOnEntry: "Girişte kullanıcıları sessize al",
	meetingsAllowScreenSharing: "Ekran paylaşımına izin ver",
	meetingsSaveAsDraft: "Taslak olarak kaydet",
	meetingsSaveMeeting: "Toplantıyı kaydet",
	meetingsCreateAndNotifyUsers: "Oluştur ve kullanıcıları bilgilendir",
	meetingsSaved: "Toplantı kaydedildi",
	meetingsSaveFailed: "Toplantı kaydedilemedi",
	meetingsJoin: "Katıl",
	meetingsOpenChat: "Sohbeti aç",
	meetingsParticipantsCount: "{count} katılımcı",
	meetingsType_video: "Video",
	meetingsType_audio: "Ses",
	meetingsType_in_person: "Yüz yüze",
	meetingsType_hybrid: "Hibrit",
	meetingsVisibility_private: "Özel",
	meetingsVisibility_company: "Şirket",
	meetingsVisibility_department: "Departman",
	meetingsStatus_draft: "Taslak",
	meetingsStatus_scheduled: "Planlandı",
	meetingsStatus_live: "Canlı",
	meetingsStatus_ended: "Bitti",
	meetingsStatus_cancelled: "İptal edildi",
	aiSettingsAction: "İşlem",
	aiSettingsAllowedModules: "İzin verilen modüller",
	aiSettingsApprove: "Onayla",
	aiSettingsApprovalFailed: "Onay başarısız",
	aiSettingsDisabled: "Devre dışı",
	aiSettingsEnabled: "Etkin",
	aiSettingsEvent: "Etkinlik",
	aiSettingsLogs: "Günlükler",
	aiSettingsLoadFailed: "AI ayarları yüklenemedi",
	aiSettingsNoGateway: "Ağ geçidi yapılandırılmadı",
	aiSettingsNoPendingApprovals: "Beklemede olan onay yok",
	aiSettingsNoLogs: "Günlük yok",
	aiSettingsNoPermission: "AI yöneticisi izni eksik.",
	aiSettingsPendingApprovals: "Beklemede olanlar",
	aiSettingsReject: "Reddet",
	aiSettingsRejectFailed: "Reddetme başarısız",
	aiSettingsRefresh: "Yenile",
	aiSettingsRequireApproval: "Onay gerekli",
	aiSettingsStatus: "Durum",
	aiSettingsTime: "Zaman",
	aiSettingsTitle: "AI Ayarları",
	aiSettingsTool: "Araç",
	aiSettingsUser: "Kullanıcı",
	aiSettingsUpdateFailed: "Ayarlar güncellenemedi",
	aiSettingsDefaultMode: "Varsayılan mod",
	aiSettingsReadOnly: "salt okunur",
	aiSettingsApprovalRequired: "onay gerekli",
	aiSettingsAdminOnly: "yalnızca yönetici",
	financeActiveCurrencies: "{count} aktif para birimi",
	financeAddCurrency: "Para birimi ekle",
	financeCurrencyCode: "Kod",
	financeCurrencyCoefficient: "Katsayı",
	financeCurrencyDefault: "Varsayılan",
	financeCurrencyName: "Ad",
	financeCurrencySymbol: "Sembol",
	financeCurrencyUse: "Kullan",
	financeLoadFailed: "Finans ayarları yüklenemedi",
	financeSaveSettings: "Ayarları kaydet",
	financeSavedMessage: "Finans ayarları kaydedildi",
	financeSaveFailed: "Finans ayarları kaydedilemedi",
	financeSelectedDefault: "Seçili varsayılan:",
	financeSettingsSubtitle:
		"Buradaki para birimleri finans ve sipariş sayfalarında varsayılan para görüntülemesini kontrol eder.",
	financeSettingsTitle: "Finans Ayarları",
	hrAccrualCoeffPreview: "Katsayı önizlemesi",
	hrAccrualCoeffPreviewLine1:
		"{accrualWorkedHours} çalışılan saat → {accrualVacationHours} tatil saati",
	hrAccrualCoeffPreviewLine2: "Çalışılan saat başına kazanılan tatil saati: {hourlyCoefficient}",
	hrAccrualCoeffStoredNote:
		"Arka uç, bordro ve izin bakiyeleri günün kısmi değerlerini yuvarlama kayması olmadan kullanabilmesi için bu tahakkuku dakika cinsinden saklar.",
	hrAccrualFixedYearly: "Sabit yıllık tatil günleri",
	hrAccrualFixedYearlyDesc:
		"Mevcut günlük veya aylık zaman çizelgesini kullanarak yıl boyunca konfigüre edilen tatil günü sayısını tahakkuk ettirir.",
	hrAccrualModelChoice:
		"Bir aktif tahakkuk modelini seçin. Yıllık günler ve çalışılan saatler katsayısı OR mantığı, birleşik değil.",
	hrAccrualSuffixMin: "dak",
	hrAccrualVacationMinutesEarned: "Kazanılan tatil dakikaları",
	hrAccrualVacationMinutesEarnedDesc:
		"Her çalışılan zaman birimi için tahakkuk eden tatil dakikaları.",
	hrAccrualWorkBreak: "Çalışma molası",
	hrAccrualWorkBreakDesc:
		"Ofisten eksik aralıklarda molalar olarak sınıflandırılan günlük kapsanmayan dakikalar.",
	hrAccrualWorkedHoursModel: "Çalışılan saatler tatil saatlerine",
	hrAccrualWorkedHoursModelDesc:
		"Yapılandırılabilir çalışılan saatler katsayısı kullanarak fiili çalışılan zamandan tatil tahakkuk ettir.",
	hrAccrualWorkedMinutesUnit: "Çalışılan dakika birimi",
	hrAccrualWorkedMinutesUnitDesc:
		"Bir tahakkuk birimi oluşturmak için kaç çalışılan dakika gerekir.",
	hrWeekdayFri: "Cum",
	hrWeekdayMon: "Paz",
	hrWeekdaySat: "Cmt",
	hrWeekdaySun: "Pzr",
	hrWeekdayThu: "Per",
	hrWeekdayTue: "Sal",
	hrWeekdayWed: "Çar",
	knowledgeSettingsAiEnabled: "AI etkin",
	knowledgeSettingsAiModel: "AI modeli",
	knowledgeSettingsAiProvider: "AI sağlayıcısı",
	knowledgeSettingsEnableAutoDocs: "Otomatik dokümanları etkinleştir",
	knowledgeSettingsLanguage: "Varsayılan dil",
	knowledgeSettingsMaxSizeMb: "En yüksek makale boyutu MB",
	knowledgeSettingsRootCategory: "Otomatik doküman kök kategorisi",
	knowledgeSettingsSaveSettings: "Ayarları Kaydet",
	knowledgeSettingsSaved: "Bilgi tabanı ayarları güncellendi",
	knowledgeSettingsTitle: "Ayarlar",
	knowledgeSettingsUploadExt: "İzin verilen yükleme uzantıları",
	knowledgeSettingsVisibility: "Varsayılan görünürlük",
	nvrAddFromList: "Listeden kamera ekle",
	nvrCamerasList: "Kamera listesi",
	nvrChannel: "Kanal",
	nvrChannelId: "ID",
	nvrChannelName: "Ad",
	nvrChannelsTitle: "Bu NVR'den kayıtlı kanallar",
	nvrConnectionDesc:
		"IP, bağlantı noktası ve yol şablonunu girin (yalnızca /.../{channel}... — VLC'de olduğu gibi, rtsp:// kısmı olmadan). RTSP kullanıcı adı ve parolası ekleyin (çoğu NVR'nin bunları gerekir). Otomatik ağ taraması çalıştırmak için Kaydet'e tıklayın veya tarama olmadan kanalları kaydetmek için aşağıdakilerden Kameralar ekle seçeneğini kullanın. Canlı görüntüleme için bir kamerayı açın; ofis haritasında cihazları olağan şekilde yerleştirin.",
	nvrConnectionTitle: "NVR — tüm kanallar için bir bağlantı",
	nvrDiscoveryFailed: "Keşif başarısız",
	nvrEnterPaths: "En az bir kanal veya yol girin.",
	nvrFoundChannels: "{n} kanal(lar) bulundu.",
	nvrFullUrl: "Tam URL (kanal 101 — yukarıdaki alanlardan otomatik)",
	nvrInitError: "NVR başlatılamadı. Sayfayı yeniden yükleyin.",
	nvrIp: "NVR IP",
	nvrIpPasswordRequired:
		"NVR IP ve kaydedilen parola gereklidir. Parolayı ayarlayın, kaydedin ve sonraki kaydetmede kanalları tarayacağız.",
	nvrLoadFailed: "NVR yüklenemedi",
	nvrLiveStatus: "Canlı Durum",
	nvrManualDesc:
		"Otomatik tarama başarısız olduğunda (örn. API, NVR'ye ulaşamıyor), kanalları burada listeleyin. Satır başına birini kullanın: 101, 201 gibi kanal numaraları, /Streaming/Channels/102 gibi yol veya tam rtsp:// URL. Yalnızca numaralar girdiğinizde yollar RTSP yol şablonunuzla birleştirilir. IP veya şablonu değiştirdiyseniz önce NVR'yi kaydedin, ardından satırlar ekleyin ve düğmeyi tıklayın.",
	nvrManualTitle: "RTSP yollarından kamera ekle (sunucu taraması yok)",
	nvrNotReady: "NVR hazır değil. Sayfayı yeniden yükleyin.",
	nvrNotReadyShort: "NVR hazır değil.",
	nvrNotWorking: "Çalışmıyor",
	nvrOfficeMap: "Ofis haritası",
	nvrOffline: "Çevrimdışı",
	nvrOnline: "Çevrimiçi",
	nvrPasswordChangeNote: "Kaydedilen parolayı güncellemek için değiştirin ve kaydedin.",
	nvrPasswordLeaveBlank: "Geçerli parolayı tutmak için boş bırakın",
	nvrPasswordRequired: "Çoğu NVR için kanalları keşfetmek ve akış yapmak için gereklidir.",
	nvrPasswordStoredLeaveBlank:
		"Parola kaydedilmiş; tutmak için boş bırakın veya yeni bir tane yazın.",
	nvrRegisterFailed: "Yollar kaydedilemedi",
	nvrRegisteredCameras: "{n} kamera(lar) kayıtlı.",
	nvrRtspPassword: "RTSP parolası",
	nvrRtspPathTemplate: "RTSP yol şablonu",
	nvrRtspPathTemplateHint:
		"{channel} ile yalnızca yolu yazın. Tam rtsp:// dizesini buraya yazmayın.",
	nvrRtspUsername: "RTSP kullanıcı adı",
	nvrScanChannels: "Kanalları yeniden tara",
	nvrScanHint: "Bu, geçerli bağlantı alanlarını kaydeder, ardından tarar.",
	nvrWorkingState: "Çalışma durumu",
	nvrWorking: "Çalışıyor",
	nvrGridEmpty: "Bu NVR'ye henüz bağlı kanal yok. NVR sayfasında keşif çalıştırın.",
	nvrGridLoadFailed: "Kanallar yüklenemedi",
	nvrGridLoading: "Kanallar yükleniyor…",
	nvrGridStreamFailed: "Başlatılamadı",
	nvrGridStreamStopped: "Akış durdu",
	nvrGridTitle: "Tüm NVR kanalları",
	securityRecordingActiveDays: "Aktif günler",
	securityRecordingDesc:
		"Sunucuda kayıt özelliği açık olan kameralar için sunucu tarafı kaydını etkinleştir. Her kamera ayrıca aşağıda kendi zamanlamasına sahip olabilir.",
	securityRecordingEndTime: "Bitiş zamanı",
	securityRecordingGlobalEnable: "Kaydı genel olarak etkinleştir",
	securityRecordingGlobalEnableDesc:
		"Ana düğme — bunu devre dışı bırakmak, kamera başına ayarlardan bağımsız olarak tüm kayıtları durdurur.",
	securityRecordingLoadFailed: "Güvenlik ayarları yüklenemedi",
	securityRecordingLocalFs: "Yerel dosya sistemi",
	securityRecordingLocalPathNote:
		"Yerel yol, sunucudaki SECURITY_RECORDING_LOCAL_PATH ortam değişkeni aracılığıyla yapılandırılır.",
	securityRecordingNoScheduleNote:
		"Zamanlama yok — sunucuda kayıt etkinleştirildiğinde kameralar 24/7 kaydedilir.",
	securityRecordingRetentionDays: "Saklama (gün)",
	securityRecordingRetentionDesc: "Bundan eski segmentler otomatik olarak silinir.",
	securityRecordingS3: "S3 / uyumlu nesne depolama",
	securityRecordingS3Note:
		"S3 kimlik bilgileri sunucudaki ortam değişkenleri aracılığıyla yapılandırılır (AWS_ACCESS_KEY_ID, AWS_SECRET_ACCESS_KEY, vb.).",
	securityRecordingSaveSettings: "Ayarları kaydet",
	securityRecordingSaved: "Güvenlik ayarları kaydedildi.",
	securityRecordingSaveFailed: "Ayarlar kaydedilemedi",
	securityRecordingScheduleDesc:
		"Bu zamanlama, sunucuda kayıt özelliği açık olan ve kendi kamera başına zamanlama geçersiz kılmaya sahip olmayan tüm kameralara uygulanır.",
	securityRecordingScheduleEnable:
		"Varsayılan zamanlamayı etkinleştir (yalnızca belirtilen saatlerde kaydet)",
	securityRecordingScheduleNote:
		"Kayıt, seçilen günlerde bu saatler arasında çalışır. Bu pencere dışında, kayıt otomatik olarak duraklatılır.",
	securityRecordingScheduleTitle: "Varsayılan kayıt zamanlaması",
	securityRecordingSegmentLength: "Segment uzunluğu (dakika)",
	securityRecordingSegmentLengthDesc:
		"Bu, her kamera sayfasında ne sıklıkla yeni bir video göründüğünü kontrol eder.",
	securityRecordingStartTime: "Başlama zamanı",
	securityRecordingStorage: "Depolama",
	securityRecordingStorageBackend: "Depolama arka ucu",
	securityRecordingTitle: "Sunucuda kamera kaydı",
	securitySurveillanceCameraMedia: "Kamera medyası",
	securitySurveillanceDashboard: "İzleme Panosu",
	securitySurveillanceNoCameras: "Kamera bulunamadı.",
	securitySurveillanceOffline: "Çevrimdışı",
	securitySurveillanceOnline: "Çevrimiçi",
	teamWorkload: "Ekip iş yükü",
	workloadTasks: "Görevler",
	workloadTickets: "Biletler",
	workloadSteps: "Adımlar",
	assignedEmployee: "Atanan çalışan",
	boughtDate: "Satın alma tarihi",
	broken: "Arızalı",
	depreciation: "Amortisman",
	deviceStatus: "Cihaz durumu",
	handoverDocument: "Teslim belgesi",
	maintenanceSchedule: "Bakım programı",
	qrCode: "QR kodu",
	repair: "Onarım",
	repairHistory: "Onarım geçmişi",
	replacementDate: "Değiştirme tarihi",
	retired: "Emekli",
	returnDocument: "İade belgesi",
	warrantyDate: "Garanti tarihi",
	noOpenWorkload: "Açık iş yükü yok",
	attendanceTable: "Devam tablosu",
	filteredFrom: "filtrelenen toplam",
	weekend: "Hafta sonu",
	late: "Geç",
	lateDeparture: "Geç çıkış",
	employees: "çalışan",
	exportToExcel: "Excel'e aktar",
	overtime: "Fazla mesai",
	attendanceNextRefresh: "Sonraki yenileme",
	refreshAttendanceDevices: "Devam cihazlarından verileri yenile",
	attendanceSyncSuccess: "Devam cihazları senkronize edildi",
	attendanceSyncFailed: "Devam cihazı senkronizasyonu başarısız",
	// User account security / profile
	contactInformation: "İletişim bilgileri",
	accountSecurity: "Hesap güvenliği",
	accountStatus: "Hesap durumu",
	accountStatusActive: "Aktif",
	accountStatusLocked: "Kilitli",
	mustChangePassword: "Şifre değiştirilmeli",
	lockedAt: "Kilitlenme zamanı",
	passwordLastChanged: "Şifre son değiştirilme",
	accountSecurityDesc: "Mevcut şifreler asla görünmez. Kimlik bilgileri değişmeliyse geçici şifre veya güvenli sıfırlama bağlantısı kullanın.",
	accountSecurityHint: "Hemen kimlik bilgisi değişimi için «Şifreyi sıfırla» kullanın. Kullanıcı yeni şifreyi yöneticiye sır göstermeden kendisi seçsin istiyorsanız «Sıfırlama bağlantısı gönder» kullanın.",
	lockAccount: "Hesabı kilitle",
	unlockAccount: "Hesabın kilidini aç",
	forcePasswordChangeAction: "Şifre değişimini zorunlu kıl",
	clearForcedPasswordChange: "Zorunlu şifre değişimini kaldır",
	resetPassword: "Şifreyi sıfırla",
	sendResetLink: "Sıfırlama bağlantısı gönder",
	sessionVisibilityRequiresPermission: "Oturum ve cihaz görünürlüğü için ek izin gerekir.",
	resetPasswordConfirmTitle: "Bu şifre sıfırlansın mı?",
	resetPasswordConfirmText: "Geçici bir şifre oluşturulacak ve kullanıcı bir sonraki girişte değiştirmelidir.",
	temporaryPasswordGenerated: "Geçici şifre oluşturuldu",
	temporaryPasswordShareHint: "Bunu yalnızca güvenli bir kanaldan paylaşın.",
	sendResetLinkConfirmTitle: "Şifre sıfırlama bağlantısı gönderilsin mi?",
	sendResetLinkConfirmText: "Kullanıcıya tek kullanımlık güvenli bir sıfırlama bağlantısı e-postalanacak.",
	passwordResetLinkSent: "Şifre sıfırlama bağlantısı gönderildi.",
	lockAccountConfirmTitle: "Bu hesap kilitlensin mi?",
	unlockAccountConfirmTitle: "Bu hesabın kilidi açılsın mı?",
	lockAccountConfirmText: "Kilit açılana kadar kullanıcı giriş yapamaz.",
	unlockAccountConfirmText: "Kullanıcı hemen yeniden giriş yapabilir.",
	accountLockedMsg: "Hesap kilitlendi.",
	accountUnlockedMsg: "Hesabın kilidi açıldı.",
	forcePasswordChangeConfirmTitle: "Sonraki girişte şifre değişimi zorunlu olsun mu?",
	removeForcedPasswordChangeConfirmTitle: "Zorunlu şifre değişimi kaldırılsın mı?",
	forcePasswordChangeConfirmText: "Kullanıcı platformu kullanmadan önce yalnızca şifre değiştirmek için giriş yapabilir.",
	removeForcedPasswordChangeConfirmText: "Kullanıcı normal şekilde giriş yapmaya devam edebilir.",
	forcedPasswordChangeEnabled: "Zorunlu şifre değişimi etkinleştirildi.",
	forcedPasswordChangeRemoved: "Zorunlu şifre değişimi kaldırıldı.",
	securityUpdated: "Güvenlik güncellendi",
	securityActionFailed: "Güvenlik işlemi başarısız",
	knownDevicesAndSessions: "Bilinen cihazlar ve açık oturumlar",
	knownDevicesAndSessionsDesc: "Konumlar yaklaşıktır ve genellikle IP kaynağı, ISS, VPN çıkışı veya ofis ağ geçidini gösterir; cihazın tam fiziksel konumunu değil.",
	openSessionsBadge: "{count} açık",
	revokeOtherSessions: "Diğer oturumları iptal et",
	registeredDevices: "Kayıtlı cihazlar",
	unknownDevice: "Bilinmeyen cihaz",
	unknownBrowser: "Bilinmeyen tarayıcı",
	unknownOs: "Bilinmeyen İşS",
	browserOnOs: "{browser} — {os}",
	firstSeen: "İlk görülme",
	sessionsBadge: "{count} oturum",
	currentDevice: "Geçerli cihaz",
	noKnownDevices: "Henüz bilinen cihaz kaydı yok.",
	approximateLoginOrigins: "Yaklaşık giriş konumları",
	sessionDetails: "Oturum ayrıntıları",
	device: "Cihaz",
	network: "Ağ",
	lastActive: "Son etkinlik",
	approximateLocationUnavailable: "Yaklaşık konum kullanılamıyor",
	revoke: "İptal et",
	noAuthSessions: "Henüz kimlik doğrulama oturumu kaydı yok.",
	sessionOriginApproximateNote: "Oturum kaynağı verileri yaklaşıktır. IP coğrafi konumunu cihazın tam konumu olarak kabul etmeyin.",
	connectedMeansNote: "Bağlı, tarayıcı/uygulamanın canlı bir soketi olduğu anlamına gelir. Bağlantı kesildi, tarayıcının kapandığı veya çevrimdışı olduğu anlamına gelir; ancak kayıtlı oturum çıkış, iptal veya süre bitimine kadar geçerli kalabilir.",
	revokeThisSessionTitle: "Bu oturum iptal edilsin mi?",
	revokeThisSessionText: "Seçilen cihaz/oturum yeniden giriş yapmak zorunda kalacak.",
	revokeSession: "Oturumu iptal et",
	sessionRevoked: "Oturum iptal edildi",
	sessionRevokedSuccess: "Seçilen oturum başarıyla iptal edildi.",
	failedToRevokeSession: "Oturum iptal edilemedi",
	unableToRevokeSession: "Seçilen oturum iptal edilemedi.",
	revokeOtherSessionsTitle: "Diğer oturumlar iptal edilsin mi?",
	revokeOtherSessionsText: "Kullanıcı kendi cihazlarını iptal ederken geçerli oturum hariç bu kullanıcının tüm oturumları iptal edilir.",
	revokeSessions: "Oturumları iptal et",
	sessionsRevoked: "Oturumlar iptal edildi",
	revokedSessionsCount: "{count} oturum iptal edildi.",
	failedToRevokeSessions: "Oturumlar iptal edilemedi",
	unableToRevokeSessions: "Seçilen oturumlar iptal edilemedi.",
	failedToLoadSessions: "Oturumlar yüklenemedi",
	unableToLoadUserSessions: "Kullanıcı oturumları yüklenemedi.",
	sessionStatusRevoked: "İptal edildi",
	sessionStatusConnected: "Bağlı",
	sessionStatusDisconnected: "Bağlantı kesildi",
	currentSession: "Geçerli",
	passwordChangeOnly: "Yalnızca şifre değişimi",
	faceId: "Face ID",
	passwordsNeverShownHint: "Şifreler burada gösterilmez. Bu hesabı kilitlemek/açmak, şifre değişimini zorunlu kılmak, geçici şifre oluşturmak veya sıfırlama bağlantısı göndermek için Güvenlik sekmesini kullanın.",
	sharedFolders: "Paylaşılan klasörler",
	flexId: "Flex Id",
	emailNotProvided: "E-posta belirtilmedi",
	anonymousUser: "Anonim kullanıcı",
	noMapPointsYet: "Henüz harita noktası yok",
	noMapPointsYetDesc: "Yaklaşık koordinatlı oturum konumları henüz yok. Backend coğrafi sağlayıcı olmadan da cihaz ve oturumları izleyebilir.",
	googleMapsKeyNotConfigured: "Google Maps anahtarı yapılandırılmadı",
	googleMapsKeyNotConfiguredDesc: "Yaklaşık oturum haritasını göstermek için REACT_APP_GOOGLE_MAPS_API_KEY ayarlayın.",
	mapFailedToLoad: "Harita yüklenemedi",
	mapFailedToLoadDesc: "Google Maps şu anda yüklenemiyor.",
	approximateLocation: "Yaklaşık konum",
	attendanceLastRefreshed: "Son yenileme",
	quarter: "Çeyrek",
	year: "Yıl",
	currentQuarter: "Geçerli çeyrek",
	currentYear: "Geçerli yıl",
	chatClearHistory: "Geçmişi temizle",
	chatClearHistoryConfirm: "Bu sohbet geçmişi yalnızca sizin için temizlensin mi?",
	chatDeleteForMe: "Sohbeti sil",
	chatDeleteForMeConfirm: "Bu sohbet yalnızca sizin için silinsin mi? Görünen geçmişiniz temizlenecek ve sohbet kenar çubuğunuzdan kaybolacak.",
	chatBlockUser: "Kullanıcıyı engelle",
	chatUnblockUser: "Kullanıcının engelini kaldır",
	chatBlockedSection: "Engellenen kişiler",
	chatBlockUserConfirm: "Bu kullanıcı engellensin mi? Bu sohbette size mesaj gönderemeyecek.",
};
